// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  // Switch,
  Divider,
  // FormControlLabel,
  Checkbox,
  Tooltip,
  IconButton,
  Button,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
// import MDBadge from "theme/components/MDBadge";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import AppConfig from "appConfig";
import { useAuthUser } from "react-auth-kit";
import MessageDialog from "app/components/message_dialog";
import Editor from "react-simple-wysiwyg";
// import QRCode from "react-qr-code";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MapPicker from "react-google-map-picker";
// import { usePlacesWidget } from "react-google-autocomplete";
// import Autocomplete from "react-google-autocomplete";
import GoogleAddressField from "app/components/google_address";

function CampaignView() {
  const pageTitle = "Manage Campaign";
  usePageTitle(pageTitle);

  const { id } = useParams();
  const navigate = useNavigate();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(voucher) {
    try {
      await navigator.clipboard.writeText(voucher);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [dispenseCount, setDispenseCount] = useState(1);
  const [paymentRequired, setPaymentRequired] = useState(false);
  const [shippingRequired, setShippingRequired] = useState(false);
  const [enforceLocationCapture, setEnforceLocationCapture] = useState(false);
  const [customerUniqueness, setCustomerUniqueness] = useState(null);
  const [feeBearer, setFeeBearer] = useState(null);
  const [openEditCampaignDialog, setOpenEditCampaignDialog] = useState(false);

  const [currency, setCurrency] = useState("₦");
  const [campaign, setCampaign] = useState({});
  const [superAgents, setSuperAgents] = useState([]);
  // const [productCount, setProductCount] = useState(0);
  const [agentCount, setAgentCount] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [selectedAgentGroup, setSelectedAgentGroup] = useState(null);
  const [meta, setMeta] = useState(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [campaignProducts, setCampaignProducts] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [salesCommissions, setSalesCommissions] = useState([]);
  const [salesIncentives, setSalesIncentives] = useState([]);
  const [purchaseIncentives, setPurchaseIncentives] = useState([]);
  const [productsRaw, setProductsRaw] = useState([]);
  const [productTitle, setProductTitle] = useState(null);
  // const [productAttributes, setProductAttributes] = useState(null);
  const [productAmount, setProductAmount] = useState(null);
  // const [productCommission, setProductCommission] = useState(0);
  const [productDispenseQty, setProductDispenseQty] = useState(1);
  const [productMaxOrderQty, setProductMaxOrderQty] = useState(0);
  const [isProductPriceFixed, setIsProductPriceFixed] = useState(true);
  const [productPriceMinimum, setProductPriceMinimum] = useState(0);
  const [productPriceMaximum, setProductPriceMaximum] = useState(0);
  const [productRestriction, setProductRestriction] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [openNewProductDialog, setOpenNewProductDialog] = useState(false);
  const [openEditProductDialog, setOpenEditProductDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [attachProductQty, setAttachProductQty] = useState(0);
  const [accountProducts, setAccountProducts] = useState([]);

  const [openNewSuperAgentDialog, setOpenNewSuperAgentDialog] = useState(false);
  const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);
  // const [openUploadProductItemsDialog, setOpenUploadProductItemsDialog] = useState(false);
  const [openUploadMaterialDialog, setOpenUploadMaterialDialog] = useState(false);

  // Branded Material
  const [materialTitle, setMaterialTitle] = useState(null);
  const [materialDocType, setMaterialDocType] = useState(null);
  const [materialContent, setMaterialContent] = useState(null);

  // Sales Commission
  const [openCreateSalesCommissionDialog, setOpenCreateSalesCommissionDialog] = useState(false);
  const [salesCommission, setSalesCommission] = useState(null);
  const [salesCommissionPercentage, setSalesCommissionPercentage] = useState(false);
  const [salesCommissionSettlement, setSalesCommissionSettlement] = useState(false);

  // Product Transfer
  const [openProductItemTransfer, setOpenProductItemTransferDialog] = useState(false);
  const [selectedProductTransfer, setSelectedProductTransfer] = useState(null);
  const [selectedDestionationProductTransfer, setSelectedDestionationProductTransfer] =
    useState(null);
  const [transferQty, setTransferQty] = useState(0);
  const [destinationCampaignProducts, setDestinationCampaignProducts] = useState([]);

  // Incentives
  const [openCreateSalesIncentiveDialog, setOpenCreateSalesIncentiveDialog] = useState(false);
  const [openCreatePurchaseIncentiveDialog, setOpenCreatePurchaseIncentiveDialog] = useState(false);
  const [incentiveDataBundles, setIncentiveDataBundles] = useState([]);
  const [incentiveTitle, setIncentiveTitle] = useState(null);
  const [incentiveType, setIncentiveType] = useState(null);
  const [incentiveTimeframe, setIncentiveTimeframe] = useState(null);
  const [incentiveIntervalType, setIncentiveIntervalType] = useState(null);
  const [incentiveTarget, setIncentiveTarget] = useState(null);
  const [incentiveTargetType, setIncentiveTargetType] = useState("COUNT");
  const [incentivePurchaseTarget, setIncentivePurchaseTarget] = useState(null);
  const [incentivePurchaseTargetType, setIncentivePurchaseTargetType] = useState("COUNT");
  const [incentiveReward, setIncentiveReward] = useState(null);
  const [incentiveIsPercentage, setIncentiveIsPercentage] = useState(false);
  const [incentiveStartDate, setIncentiveStartDate] = useState(null);
  const [incentiveEndDate, setIncentiveEndDate] = useState(null);
  const [incentiveIntervalTime, setIncentiveIntervalTime] = useState(null);
  const incentiveIntervalTimes = [
    { name: "12am", value: "00:00:00" },
    { name: "1am", value: "01:00:00" },
    { name: "3am", value: "02:00:00" },
    { name: "3am", value: "03:00:00" },
    { name: "4am", value: "04:00:00" },
    { name: "5am", value: "05:00:00" },
    { name: "6am", value: "06:00:00" },
    { name: "7am", value: "07:00:00" },
    { name: "8am", value: "08:00:00" },
    { name: "9am", value: "09:00:00" },
    { name: "10am", value: "10:00:00" },
    { name: "11am", value: "11:00:00" },
    { name: "12pm", value: "12:00:00" },
    { name: "1pm", value: "13:00:00" },
    { name: "2pm", value: "14:00:00" },
    { name: "3pm", value: "15:00:00" },
    { name: "4pm", value: "16:00:00" },
    { name: "5pm", value: "17:00:00" },
    { name: "6pm", value: "18:00:00" },
    { name: "7pm", value: "19:00:00" },
    { name: "8pm", value: "20:00:00" },
    { name: "9pm", value: "21:00:00" },
    { name: "10pm", value: "22:00:00" },
    { name: "11pm", value: "23:00:00" },
  ];

  // API Endpoints
  const [endpoints, setEndpoints] = useState([]);
  const [apiEndpointType, setApiEndpointType] = useState(null);
  const [apiEndpointUrl, setApiEndpointUrl] = useState(null);
  const [openAddApiEndpointDialog, setOpenAddApiEndpointDialog] = useState(false);

  // Data Forms
  const [dataForms, setDataForms] = useState([]);
  const [campaignDataForms, setCampaignDataForms] = useState([]);
  const [selectedDataForm, setSelectedDataForm] = useState(null);
  const [openAttachDataFormDialog, setOpenAttachDataFormDialog] = useState(false);

  // Courses
  const [accountCourses, setAccountCourses] = useState([]);
  const [campaignCourses, setCampaignCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [openAttachCourseialog, setOpenAttachCourseDialog] = useState(false);

  // Customer Pools
  const [campaignCustomerPools, setCampaignCustomerPools] = useState([]);

  // Locations
  const [campaignLocations, setCampaignLocations] = useState([]);
  const [locationTitle, setLocationTitle] = useState(null);
  const [locationLat, setLocationLat] = useState(null);
  const [locationLng, setLocationLng] = useState(null);
  const [locationRad, setLocationRad] = useState(30);
  const [restrictSalesToLocation, setRestrictSalesToLocation] = useState(true);
  const [enforceFaceMatch, setEnforceFaceMatch] = useState(true);
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [selectedCampaignLocation, setSelectedCampaignLocation] = useState(null);
  const [checkinGracePeriod, setCheckinGracePeriod] = useState(null);
  const [openRequestCheckinDialog, setOpenRequestCheckinDialog] = useState(false);
  const [locationCheckInTimeOfDay, setLocationCheckInTimeOfDay] = useState(null);
  const [openScheduleCheckinDialog, setOpenScheduleCheckinDialog] = useState(false);
  const [centerLocation, setCenterLocation] = useState(null);
  // const [enableAttendance, setEnableAttendance] = useState(false);
  // const [isPhotoAttendance, setIsPhotoAttendance] = useState(true);
  // const [attendanceHour, setAttendanceHour] = useState(null);
  // const [attendanceGracePeriod, setAttendanceGracePeriod] = useState(60);

  // function onLocationSuccess(position) {
  //   setCenterLocation({
  //     lat: position.coords.latitude,
  //     lng: position.coords.longitude,
  //   });
  // }

  // function getGPSCoords() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(onLocationSuccess, null, {
  //       enableHighAccuracy: true,
  //       timeout: 50000,
  //     });
  //   }
  //   return false;
  // }

  // const { googleAddressRef } = usePlacesWidget({
  //   apiKey: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
  //   onPlaceSelected: (place) => {
  //     // console.log(place);
  //     // setGoogleAddressFormatted(place.formatted_address);
  //     setLocationLat(place.geometry.location.lat());
  //     setLocationLng(place.geometry.location.lng());
  //     setCenterLocation({
  //       lat: place.geometry.location.lat(),
  //       lng: place.geometry.location.lng(),
  //     });
  //   },
  //   options: {
  //     // types: ["(regions)"],
  //     componentRestrictions: { country: "ng" },
  //   },
  // });

  // Shipping Rates
  const [shippingRates, setShippingRates] = useState([]);
  const [campaignShippingRates, setCampaignShippingRates] = useState([]);
  const [selectedShippingRate, setSelectedShippingRate] = useState(null);
  const [openAttachShippingDialog, setOpenAttachShippingDialog] = useState(false);

  // Campaign Views
  const [campaignViews, setCampaignViews] = useState([]);
  const [campaignViewEmail, setCampaignViewEmail] = useState(null);
  const [campaignViewAccessType, setCampaignViewAccessType] = useState(null);
  const [openCreateCampaignViewDialog, setOpenCreateCampaignViewDialog] = useState(false);

  // Message
  const [showMessageComponentDialog, setShowMessageComponentDialog] = useState(false);

  // Aggregators
  const [campaignAggregators, setCampaignAggregators] = useState([]);
  const [aggregators, setAggregators] = useState([]);
  const [selectedAggregator, setSelectedAggregator] = useState(null);
  const [aggregatorQuota, setAggregatorQuota] = useState(null);
  const [openAddAggregatorDialog, setOpenAddAggregatorDialog] = useState(false);

  // Preset Amounts
  const [presetAmount, setPresetAmount] = useState(null);
  const [presetAmountTitle, setPresetAmountTitle] = useState(null);
  const [presetAmountType, setPresetAmountType] = useState(null);
  const [presetAmountAmt, setPresetAmountAmt] = useState(null);
  const [presetAmountMin, setPresetAmountMin] = useState(null);
  const [presetAmountMax, setPresetAmountMax] = useState(null);
  const [presetAmountFeeBearer, setPresetAmountFeeBearer] = useState("MERCHANT");
  const [openAddPresetAmountDialog, setOpenAddPresetAmountDialog] = useState(false);

  // Packages
  const [packages, setPackages] = useState([]);
  const [campaignPackage, setCampaignPackage] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPackageObject, setSelectedPackageObject] = useState(null);
  const [packageDuration, setPackageDuration] = useState(1);
  const [openPackageDialog, setOpenPackageDialog] = useState(false);

  // Sharing
  // const qrCodeRef = useRef(null);

  function onLocationPicked(clat, clng) {
    setLocationLat(clat);
    setLocationLng(clng);
  }

  useEffect(() => {
    if (locationLat === null) {
      return;
    }
    if (locationLng === null) {
      return;
    }
    // console.log(locationLat);
    // console.log(locationLng);

    setCenterLocation({
      lat: locationLat,
      lng: locationLng,
    });
  }, [locationLat, locationLng]);

  // function generateTimeArray() {
  //   const startTime = new Date();
  //   const endTime = new Date();
  //   startTime.setHours(0, 0, 0, 0);
  //   endTime.setHours(23, 59, 0, 0);

  //   const timeArray = [];
  //   const currentTime = new Date(startTime);

  //   while (currentTime <= endTime) {
  //     const hours = String(currentTime.getHours()).padStart(2, "0");
  //     const minutes = String(currentTime.getMinutes()).padStart(2, "0");
  //     timeArray.push(`${hours}:${minutes}`);
  //     currentTime.setMinutes(currentTime.getMinutes() + 30);
  //   }

  //   return timeArray;
  // }

  // const scheduleTimes = generateTimeArray();

  function shareLink(platform, c) {
    const link = c.web_link;
    const msg = `Interested in *${encodeURIComponent(
      c.title
    )}*?%0aClick the link to see available products.%0a%0a${encodeURIComponent(link)}`;
    let url = "";
    if (platform === "whatsapp") {
      url = `whatsapp://send?text=${msg}`;
    } else {
      url = `https://t.me/share/url?url=${msg}`;
    }
    window.open(url, "_blank");
  }

  function shareLinkProduct(platform, prdct) {
    const plink = prdct.web_link;
    let msg = `${
      prdct.price !== null && prdct.price
        ? `%0a*${prdct.currency.symbol}${(prdct.price / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}*%0a`
        : ""
    }`;
    msg = `${encodeURIComponent(prdct.title)}.${msg}%0a*Buy Now*%0a${encodeURIComponent(plink)}`;
    let url = "";
    if (platform === "whatsapp") {
      url = `whatsapp://send?text=${msg}`;
    } else {
      url = `https://t.me/share/url?url=${msg}`;
    }
    window.open(url, "_blank");
  }

  async function webShare(subject, text, url, imageUrl = null) {
    if (navigator.share === "undefined") {
      alert("Your browser does not support this feature.");
      return;
    }

    imageUrl = null;
    let shareObject = {};
    if (imageUrl !== null) {
      setShowLoading(true);
      try {
        const image = await fetch(imageUrl, { cache: "no-cache" });
        console.log(image);
        const blobData = await image.blob();
        console.log(blobData);
        const fileObj = new File([blobData], `product.jpg`, { type: blobData.type });

        // shareObject.files = [fileObj];
        text = `${text}. ${url}`;
        shareObject = {
          title: `${subject}`,
          text: `${text}`,
          files: [fileObj],
          url: `${url}`,
        };
        setShowLoading(false);
      } catch (error) {
        setShowLoading(false);
        shareObject = {
          title: `${subject}`,
          text: `${text}`,
          url: `${url}`,
        };
      }
    } else {
      shareObject = {
        title: `${subject}`,
        text: `${text}`,
        url: `${url}`,
      };
    }

    try {
      navigator
        .share(shareObject)
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch((err) => {
          // Handle errors, if occurred
          console.log("Error while using Web share API:");
          console.log(err);
        });
    } catch (err) {
      console.error("Share failed:", err.message);
      alert("Your browser does not support this feature.");
    }
  }

  function shareWebProduct(prdct, imageUrl) {
    const plink = prdct.web_link;
    const msg = `Buy ${prdct.title} ${
      prdct.price !== null && prdct.price
        ? `at ${prdct.currency.symbol}${(prdct.price / 100).toLocaleString("en", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : ""
    }. Click link for more info.`;

    webShare(prdct.title, msg, plink, imageUrl);
  }

  function shareWebCampaign(c) {
    const link = c.web_link;
    const msg = `Interested in ${c.title}? Click the link to see available products.`;
    webShare(c.title, msg, link);
  }

  async function deleteCampaign() {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/${id}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSeverity("success");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          // setRefreshPage(!refreshPage);
          navigate("/campaigns");
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateCampaignLocationStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/locations/${ref}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteCampaignLocation(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/locations/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeDataForm(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/data_form/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeCampaignCourse(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/courses/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeCustomerPool(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/customer_pool/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removePresetAmount(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/preset_amounts/${ref}/remove.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeCampaignView(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/windows/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeApiEndpoint(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/api_endpoints/${ref}/remove.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeShipping(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/shipping_rates/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAggregator(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/aggregators/${ref}/remove.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateAggregatorStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/aggregators/${ref}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgentGroup(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/agentGroups/${ref}/remove.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateAgentGroupStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/agentGroups/${ref}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateProductStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/products/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteProduct(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/products/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateCommissionStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/commissions/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteSalesCommission(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/commissions/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function releaseCommissions(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/commissions/${ref}/payout.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateSalesIncentiveStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/incentives/sales/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteSalesIncentive(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/incentives/sales/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updatePurchaseIncentiveStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/incentives/purchase/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deletePurchaseIncentive(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/incentives/purchase/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteMaterial(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/materials/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const productTableColumns = [
    { Header: "Actions", accessor: "reference", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Price Fixed?", accessor: "fixed", align: "left" },
    { Header: "Price Minimum", accessor: "min_price", align: "left" },
    { Header: "Price Maximum", accessor: "max_price", align: "left" },
    { Header: "Items", accessor: "items", align: "left" },
    // { Header: "Commission", accessor: "commission", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Added On", accessor: "created", align: "right" },
    // { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildProductRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        reference: (
          <MDBox>
            <MDBox ml={-1} mt={1} display="flex" justifyContent="space-between" alignItems="start">
              <Tooltip title={`${row.status ? "Disable" : "Enable"} Product`}>
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={() => {
                    if (
                      window.confirm(`${row.status ? "Disable" : "Enable"} this product?`) === true
                    ) {
                      updateProductStatus(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    {row.status ? "pause" : "play_arrow"}
                  </Icon>
                </MDButton>
              </Tooltip>
              <Tooltip title="Edit Product">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="warning"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Edit product?`) === true) {
                      setProductTitle(row.title);
                      setProductAmount(row.price / 100);
                      setProductRestriction(row.order_restriction);
                      setProductMaxOrderQty(row.order_quantity);
                      setSelectedProduct(row.reference);
                      setIsProductPriceFixed(row.is_price_fixed);
                      setProductPriceMinimum(row.price_minimum / 100);
                      setProductPriceMaximum(row.price_maximum / 100);
                      setOpenEditProductDialog(true);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    edit
                  </Icon>
                </MDButton>
              </Tooltip>
              <Tooltip title="Download Product Items">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Download products?`) === true) {
                      const downloadUrl = `${AppConfig.api_base_url}portal/campaigns/products/${row.reference}/${accountInfo.user.reference}/download.json`;
                      window.open(downloadUrl, "_blank");
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    download
                  </Icon>
                </MDButton>
              </Tooltip>
              <Tooltip title="Remove Product">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete product?`) === true) {
                      deleteProduct(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
            <Divider />
            <MDBox ml={-1} mt={1} display="flex" justifyContent="space-between" alignItems="start">
              <a href={row.web_link} target="_blank" rel="noreferrer">
                <IconButton size="small" variant="outlined" color="dark">
                  <Icon>send</Icon>
                </IconButton>
              </a>
              <IconButton
                size="small"
                variant="outlined"
                color="info"
                onClick={() => copy(row.web_link)}
              >
                <Icon>copy</Icon>
              </IconButton>
              <IconButton size="small" onClick={() => shareLinkProduct("whatsapp", row)}>
                <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
              </IconButton>
              <IconButton size="small" onClick={() => shareLinkProduct("telegram", row)}>
                <Icon color="info">telegram</Icon>
              </IconButton>
              <IconButton
                size="small"
                onClick={() => shareWebProduct(row, `${AppConfig.api_cors_url}media/${row.image}`)}
              >
                <Icon color="dark">share</Icon>
              </IconButton>
            </MDBox>
          </MDBox>
        ),
        name: (
          <span>
            {row.title}
            {row.is_price_fixed && (
              <>
                <br />
                {`${currency}${(row.price / 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
              </>
            )}
            <MDTypography mt={1} variant="h6" fontWeight="light">
              <small>Ref: {row.reference}</small>
            </MDTypography>
          </span>
        ),
        fixed: row.is_price_fixed ? "FIXED" : "OPEN",
        min_price: `${currency}${(row.price_minimum / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        max_price: `${currency}${(row.price_maximum / 100).toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        items: `${row.item_count.used} / ${row.item_count.total}`,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const commissionsTableColumns = [
    { Header: "Commission", accessor: "commission", align: "left" },
    { Header: "Product", accessor: "product", align: "left" },
    { Header: "Settlement", accessor: "settlement", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildCommissionsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        product: campaign.campaign_type !== "DATA" ? row.product : "N/A",
        commission: (
          <span>
            {!row.is_commission_percentage
              ? `${currency}${(row.commission / 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : `${(row.commission * 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}%`}
          </span>
        ),
        settlement: row.instant_settlement ? "Automated" : "Manual",
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // created: row.created,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (
                  window.confirm(`${row.status ? "Pause" : "Resume"} this commission?`) === true
                ) {
                  updateCommissionStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="success"
              iconOnly
              onClick={() => {
                if (window.confirm(`Pay out now?`) === true) {
                  releaseCommissions(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                money
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="dark"
              iconOnly
              onClick={() => {
                const downloadUrl = `${AppConfig.api_base_url}reports/commissions/${row.reference}/${accountInfo.user.reference}`;
                window.open(downloadUrl, "_blank");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this commission?`) === true) {
                  deleteSalesCommission(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const salesIncentiveTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Product", accessor: "product", align: "left" },
    { Header: "Period", accessor: "time_interval", align: "left" },
    { Header: "Target", accessor: "target", align: "left" },
    { Header: "Target Type", accessor: "target_type", align: "left" },
    { Header: "Type", accessor: "incentive_type", align: "left" },
    { Header: "Reward", accessor: "reward", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildSalesincentiveRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        product: campaign.campaign_type !== "DATA" ? row.product : "N/A",
        time_interval: `${row.time_interval} day(s)`,
        target: row.target,
        target_type: row.target_type,
        incentive_type: row.incentive_type,
        reward:
          row.incentive_type === "DATA" ? (
            row.reward
          ) : (
            <span>
              {!row.is_reward_commission_percentage
                ? `${currency}${(row.reward / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : `${(row.reward * 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}%`}
            </span>
          ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // created: row.created,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (window.confirm(`${row.status ? "Pause" : "Resume"} this incentive?`) === true) {
                  updateSalesIncentiveStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="dark"
              iconOnly
              onClick={() => {
                const downloadUrl = `${AppConfig.api_base_url}reports/incentives/sales/${row.reference}/${accountInfo.user.reference}`;
                window.open(downloadUrl, "_blank");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this incentive?`) === true) {
                  deleteSalesIncentive(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const purchaseIncentiveTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Product", accessor: "product", align: "left" },
    { Header: "Period", accessor: "time_interval", align: "left" },
    { Header: "Target", accessor: "target", align: "left" },
    { Header: "Target Type", accessor: "target_type", align: "left" },
    { Header: "Type", accessor: "incentive_type", align: "left" },
    { Header: "Reward", accessor: "reward", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildPurchaseIncentiveRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        product: row.product,
        time_interval: `${row.time_interval} day(s)`,
        target: row.target,
        target_type: row.target_type,
        incentive_type: row.incentive_type,
        reward:
          row.incentive_type === "DATA" ? (
            row.reward
          ) : (
            <span>
              {!row.is_reward_price_percentage
                ? `${currency}${(row.reward / 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : `${(row.reward * 100).toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}%`}
            </span>
          ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // created: row.created,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (window.confirm(`${row.status ? "Pause" : "Resume"} this incentive?`) === true) {
                  updatePurchaseIncentiveStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="dark"
              iconOnly
              onClick={() => {
                const downloadUrl = `${AppConfig.api_base_url}reports/incentives/purchase/${row.reference}/${accountInfo.user.reference}`;
                window.open(downloadUrl, "_blank");
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                download
              </Icon>
            </MDButton>
            &nbsp;&nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this incentive?`) === true) {
                  deletePurchaseIncentive(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const materialTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Material", accessor: "material", align: "left" },
    { Header: "Action", accessor: "status", align: "center" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildMaterialRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        type: row.document_type,
        material:
          row.document_type !== "LINK" ? (
            <a href={row.material} target="_blank" rel="noreferrer">
              <Icon sx={{ fontWeight: "bold" }}>download</Icon>
            </a>
          ) : (
            <a href={row.content} target="_blank" rel="noreferrer">
              <Icon sx={{ fontWeight: "bold" }}>send</Icon>
            </a>
          ),
        status: (
          <MDButton
            iconOnly
            onClick={() => {
              if (window.confirm(`Delete ${row.title}?`) === true) {
                deleteMaterial(row.reference);
              }
            }}
            color="error"
            variant="outlined"
            size="small"
          >
            <Icon>delete</Icon>
          </MDButton>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  const superAgentTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
    { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildSuperAgentRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (window.confirm(`${row.status ? "Disable" : "Enable"} this group?`) === true) {
                  updateAgentGroupStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this group?`) === true) {
                  deleteAgentGroup(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const aggregatorsTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Quota", accessor: "quota", align: "center" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildAggregatorsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        quota: row.quota ? row.quota : "Unlimited",
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (
                  window.confirm(`${row.status ? "Disable" : "Enable"} this supervisor?`) === true
                ) {
                  updateAggregatorStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this supervisor?`) === true) {
                  deleteAggregator(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const endpointTableColumns = [
    { Header: "Type", accessor: "endpoint_type", align: "left" },
    { Header: "Endpoint", accessor: "endpoint_url", align: "left" },
    // { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildEndpointRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        endpoint_type: row.endpoint_type,
        endpoint_url: row.endpoint_url,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this endpoint?`) === true) {
                  removeApiEndpoint(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignDataFormsTableColumns = [
    { Header: "Data Form", accessor: "data_form", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignDataFormsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        data_form: row.title,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove data form?`) === true) {
                  removeDataForm(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignCoursesTableColumns = [
    { Header: "Course", accessor: "course", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignCoursesRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        course: row.title,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove course?`) === true) {
                  removeCampaignCourse(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const campaignCustomerPoolsTableColumns = [
    { Header: "Customer Pool", accessor: "pool", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignCustomerPoolRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        pool: row.title,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove customer pool?`) === true) {
                  removeCustomerPool(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignShippingTableColumns = [
    { Header: "Collection", accessor: "collection", align: "left" },
    { Header: "Added On", accessor: "created", align: "right" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignShippingRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        collection: row.title,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove collection?`) === true) {
                  removeShipping(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignLocationsTableColumns = [
    { Header: "Location Name", accessor: "title", align: "left" },
    { Header: "Coverage Radius", accessor: "radius", align: "left" },
    { Header: "Location Status", accessor: "status", align: "center" },
    { Header: "Geo-Fence Restricted", accessor: "restricted", align: "center" },
    // { Header: "Attendance Enabled", accessor: "attendance", align: "center" },
    // { Header: "Attendance Time", accessor: "attendance_time", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignLocationsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        // latitude: row.latitude,
        // longitude: row.longitude,
        radius: `${row.coverage_radius}m`,
        restricted: (
          <MDBox>
            <Icon color={row.restrict_sales ? "success" : "error"}>
              {row.restrict_sales ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        // attendance: (
        //   <MDBox>
        //     <Icon color={row.attendance_required ? "success" : "error"}>
        //       {row.attendance_required ? "check_circle" : "cancel"}
        //     </Icon>
        //   </MDBox>
        // ),
        // attendance_time: row.attendance_hour ? row.attendance_hour : "---",
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ width: "100%" }}>
            <MDBox mt={1} display="flex" justifyContent="space-evenly" alignItems="start">
              {/* {row.attendance_required && (
                <>
                  <Tooltip title="Attendance Logs">
                    <MDButton
                      size="small"
                      variant="outlined"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        navigate(`/location-attendance/${row.reference}`);
                      }}
                    >
                      <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                        checklist
                      </Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;&nbsp;
                </>
              )} */}
              <Tooltip title="Request Agent Check-in">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  iconOnly
                  onClick={() => {
                    setSelectedCampaignLocation(row.reference);
                    setOpenRequestCheckinDialog(true);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    person_pin
                  </Icon>
                </MDButton>
              </Tooltip>
              &nbsp;
              <Tooltip title="Agent Check-ins">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="dark"
                  iconOnly
                  onClick={() => {
                    navigate(`/location-check-ins/${row.reference}`);
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    list
                  </Icon>
                </MDButton>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip title="View On Map">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="warning"
                  iconOnly
                  onClick={() => {
                    const maplink = `https://maps.google.com?q=${row.latitude},${row.longitude}`;
                    window.open(maplink, "_blank");
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    location_on
                  </Icon>
                </MDButton>
              </Tooltip>
              &nbsp;
              <Tooltip title={`${row.status ? "Disable" : "Enable"} Location?`}>
                <MDButton
                  size="small"
                  variant="outlined"
                  color="info"
                  iconOnly
                  onClick={() => {
                    if (
                      window.confirm(`${row.status ? "Disable" : "Enable"} this location?`) === true
                    ) {
                      updateCampaignLocationStatus(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    {row.status ? "pause" : "play_arrow"}
                  </Icon>
                </MDButton>
              </Tooltip>
              &nbsp;
              <Tooltip title="Delete Location?">
                <MDButton
                  size="small"
                  variant="outlined"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Delete location?`) === true) {
                      deleteCampaignLocation(row.reference);
                    }
                  }}
                >
                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                    delete
                  </Icon>
                </MDButton>
              </Tooltip>
            </MDBox>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const campaignViewTableColumns = [
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Access Type", accessor: "access_type", align: "left" },
    { Header: "Link", accessor: "link", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignViewsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        // title: row.title,
        email: row.email_address,
        access_type: row.access_type,
        link: (
          <a href={`${row.link}`} target="_blank" rel="noreferrer">
            {row.link}
          </a>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove access?`) === true) {
                  removeCampaignView(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  async function updateStatus() {
    setShowLoading(true);
    await axios
      .get(`/portal/campaigns/${id}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/campaigns/${id}/get.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setCurrency(result.data.data.currency);
            setCampaign(result.data.data.campaign);
            setTitle(result.data.data.campaign.title);
            setDescription(result.data.data.campaign.description);
            setPaymentRequired(result.data.data.campaign.payment_required);
            setFeeBearer(result.data.data.campaign.fee_bearer);
            setShippingRequired(result.data.data.campaign.is_shipping_required);
            setEnforceLocationCapture(result.data.data.campaign.enforce_location_capture);
            setCustomerUniqueness(result.data.data.campaign.unique_customer);
            // setProductCount(result.data.data.product_count);
            // setItemCount(result.data.data.item_count);
            setAgentCount(result.data.data.agents);
            setMeta(result.data.data.meta);
            // setSuperAgentsRaw(result.data.data.super_agents);
            setAgentGroups(result.data.data.agent_groups);
            setDataForms(result.data.data.data_forms);
            setShippingRates(result.data.data.shipping_rates);
            setAccountProducts(result.data.data.products);
            setAccountCourses(result.data.data.account_courses);

            const sArows = buildSuperAgentRows(result.data.data.super_agents);
            setSuperAgents(sArows);

            setProductsRaw(result.data.data.campaign.products);
            const pArows = buildProductRows(result.data.data.campaign.products);
            setCampaignProducts(pArows);

            const mRows = buildMaterialRows(result.data.data.materials);
            setMaterials(mRows);

            const scRows = buildCommissionsRows(result.data.data.commissions);
            setSalesCommissions(scRows);

            setIncentiveDataBundles(result.data.data.incentives.data_bundles);
            const salesIncentiveRows = buildSalesincentiveRows(result.data.data.incentives.sales);
            setSalesIncentives(salesIncentiveRows);

            const purchaseIncentiveRows = buildPurchaseIncentiveRows(
              result.data.data.incentives.purchase
            );
            setPurchaseIncentives(purchaseIncentiveRows);

            const endpointRows = buildEndpointRows(result.data.data.api_endpoints);
            setEndpoints(endpointRows);

            const cDataFormsRows = buildCampaignDataFormsRows(result.data.data.campaign_data_forms);
            setCampaignDataForms(cDataFormsRows);

            const cCoursesRows = buildCampaignCoursesRows(result.data.data.campaign_courses);
            setCampaignCourses(cCoursesRows);

            const cCustomerPoolsRows = buildCampaignCustomerPoolRows(
              result.data.data.customer_pools
            );
            setCampaignCustomerPools(cCustomerPoolsRows);

            setAggregators(result.data.data.aggregators);
            const cAggregators = buildAggregatorsRows(result.data.data.campaign_aggregators);
            setCampaignAggregators(cAggregators);

            const cShippingCollections = buildCampaignShippingRows(
              result.data.data.campaign_shipping_rates
            );
            setCampaignShippingRates(cShippingCollections);

            const cLocs = buildCampaignLocationsRows(result.data.data.campaign_locations);
            setCampaignLocations(cLocs);

            const cpViews = buildCampaignViewsRows(result.data.data.campaign_views);
            setCampaignViews(cpViews);

            setPresetAmount(result.data.data.preset_amount);

            setPackages(result.data.data.packages);
            setCampaignPackage(result.data.data.campaign_package);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createProduct() {
    if (selectedProduct === null) {
      setSeverity("error");
      setErrMsg("A product is required.");
      setOpen(true);
      return;
    }

    if (productRestriction === null) {
      setSeverity("error");
      setErrMsg("Order restriction is required.");
      setOpen(true);
      return;
    }

    if (parseInt(attachProductQty, 10) < 0 || attachProductQty === "") {
      setSeverity("error");
      setErrMsg("Product quantity is invalid.");
      setOpen(true);
      return;
    }

    if (parseInt(productDispenseQty, 10) <= 0 || productDispenseQty === "") {
      setSeverity("error");
      setErrMsg("Item quantity per sale is required.");
      setOpen(true);
      return;
    }

    const tNum = Number(productMaxOrderQty);

    setOpenNewProductDialog(false);
    setShowLoading(true);
    const json = {
      product: selectedProduct,
      quantity: attachProductQty,
      voucher_dispense_count: productDispenseQty,
      order_restriction: productRestriction,
      order_quantity: tNum ? productMaxOrderQty : 0,
      campaign: campaign.reference,
      is_price_fixed: isProductPriceFixed,
      price_minimum: productPriceMinimum * 100,
      price_maximum: productPriceMaximum * 100,
    };

    await axios
      .post("portal/campaigns/products/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editProduct() {
    if (productTitle === null) {
      setSeverity("error");
      setErrMsg("Product name is required.");
      setOpen(true);
      return;
    }

    if (productAmount === null) {
      setSeverity("error");
      setErrMsg("Product price is required.");
      setOpen(true);
      return;
    }

    if (productRestriction === null) {
      setSeverity("error");
      setErrMsg("Order restriction is required.");
      setOpen(true);
      return;
    }

    if (isProductPriceFixed === false) {
      if (productPriceMinimum === null || parseFloat(productPriceMinimum, 10) < 0) {
        setSeverity("error");
        setErrMsg("Invalid price minimum");
        setOpen(true);
        return;
      }

      if (productPriceMaximum === null || parseFloat(productPriceMaximum, 10) < 0) {
        setSeverity("error");
        setErrMsg("Invalid price maximum");
        setOpen(true);
        return;
      }
    }

    if (isProductPriceFixed === true) {
      if (productAmount === null || parseFloat(productAmount, 10) < 0) {
        setSeverity("error");
        setErrMsg("Product price is required.");
        setOpen(true);
        return;
      }
    }

    const tNum = Number(productMaxOrderQty);

    setOpenEditProductDialog(false);
    setShowLoading(true);
    const json = {
      title: `${productTitle}`,
      price: productAmount * 100,
      order_restriction: productRestriction,
      order_quantity: tNum ? productMaxOrderQty : 0,
      is_price_fixed: isProductPriceFixed,
      price_minimum: productPriceMinimum * 100,
      price_maximum: productPriceMaximum * 100,
    };

    await axios
      .post(`portal/campaigns/products/${selectedProduct}/edit.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createSuperAgent() {
    if (selectedAgentGroup === null) {
      setSeverity("error");
      setErrMsg("An agent group is required.");
      setOpen(true);
      return;
    }

    setOpenNewSuperAgentDialog(false);
    setShowLoading(true);
    const json = {
      // title: `${superAgentTitle}`,
      campaign: campaign.reference,
      group: selectedAgentGroup,
      commission: 0,
    };

    await axios
      .post("portal/campaigns/agent_group/assign.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg("Agent group assigned!");
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignAggregator() {
    if (selectedAggregator === null) {
      setSeverity("error");
      setErrMsg("A supervisor is required.");
      setOpen(true);
      return;
    }

    setOpenAddAggregatorDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      aggregator: selectedAggregator,
      commission: 0,
      quota: aggregatorQuota,
    };

    await axios
      .post("portal/campaigns/aggregators/assign.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/campaigns/agents/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadAgents = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();

    // if (selectedSuperAgent) {
    //   formData.append("super_agent", selectedSuperAgent);
    // }
    formData.append("campaign", campaign.reference);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadAgentsDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  const uploadMaterial = async () => {
    if (materialTitle === null) {
      setSeverity("error");
      setErrMsg("Name is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (materialDocType === null) {
      setSeverity("error");
      setErrMsg("Document type is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (["PDF", "IMAGE", "WORD", "EXCEL"].includes(materialDocType)) {
      if (!uploadFile) {
        setSeverity("error");
        setErrMsg("Upload file is required");
        setOpen(true);
        setShowLoading(false);
        return;
      }
    }

    if (!["PDF", "IMAGE", "WORD", "EXCEL"].includes(materialDocType)) {
      if (materialContent === null) {
        setSeverity("error");
        setErrMsg("Content is required");
        setOpen(true);
        setShowLoading(false);
        return;
      }
    }

    const formData = new FormData();
    formData.append("campaign", campaign.reference);
    formData.append("title", materialTitle);
    formData.append("document_type", materialDocType);
    formData.append("content", materialContent);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadMaterialDialog(false);
    setShowLoading(true);

    await axios
      .post("portal/campaigns/materials/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Upload successful.");
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  function fileSelected(e, any = false) {
    e.persist();
    if (!any) {
      const fileTypes = ["xlsx", "xls", "csv"];
      const file = e.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const supported = fileTypes.indexOf(extension) > -1;
      if (!supported) {
        setSeverity("error");
        setErrMsg("Only excel and csv files accepted.");
        setOpen(true);
        return;
      }
    }

    setUploadFile(e.target.files[0]);
  }

  function getDestinationCampaignProducts(ref) {
    setSelectedDestionationProductTransfer(null);
    meta.campaigns.every((row) => {
      if (row.reference === ref) {
        setDestinationCampaignProducts(row.products);
      }
      return true;
    });
  }

  async function transferProductObjects() {
    if (selectedProductTransfer === null) {
      setSeverity("error");
      setErrMsg("Source product is required");
      setOpen(true);
      return;
    }

    if (selectedDestionationProductTransfer === null) {
      setSeverity("error");
      setErrMsg("Destination product is required");
      setOpen(true);
      return;
    }

    if (transferQty === null || transferQty <= 0) {
      setSeverity("error");
      setErrMsg("Quantity is required");
      setOpen(true);
      return;
    }

    setOpenProductItemTransferDialog(false);
    setShowLoading(true);

    const json = {
      from: selectedProductTransfer,
      to: selectedDestionationProductTransfer,
      quantity: transferQty,
    };

    await axios
      .post("portal/campaigns/transfer/products.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createCommission() {
    if (salesCommission === null) {
      setSeverity("error");
      setErrMsg("Commission is required.");
      setOpen(true);
      return;
    }

    setOpenCreateSalesCommissionDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      commission: salesCommission,
      is_commission_percentage:
        campaign.campaign_type !== "DATA" ? salesCommissionPercentage : false,
      instant_settlement: salesCommissionSettlement,
      product: campaign.campaign_type !== "DATA" ? selectedProduct : "ALL",
    };

    await axios
      .post("portal/campaigns/commissions/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createSalesIncentive() {
    if (incentiveType === null) {
      setSeverity("error");
      setErrMsg("Incentive type is required.");
      setOpen(true);
      return;
    }
    if (incentiveTitle === null) {
      setSeverity("error");
      setErrMsg("Incentive name is required.");
      setOpen(true);
      return;
    }

    if (incentiveTarget === null) {
      setSeverity("error");
      setErrMsg("Incentive target is required.");
      setOpen(true);
      return;
    }

    if (incentiveTargetType === null) {
      setSeverity("error");
      setErrMsg("Incentive target type is required.");
      setOpen(true);
      return;
    }

    if (incentiveReward === null) {
      setSeverity("error");
      setErrMsg("Incentive reward is required.");
      setOpen(true);
      return;
    }

    if (incentiveTimeframe === null) {
      setSeverity("error");
      setErrMsg("Incentive time interval is required.");
      setOpen(true);
      return;
    }

    if (incentiveIntervalType === null || incentiveIntervalType === "") {
      setSeverity("error");
      setErrMsg("Incentive interval type is required.");
      setOpen(true);
      return;
    }

    if (incentiveIntervalType === "CYCLE") {
      if (incentiveStartDate === null || incentiveStartDate === "") {
        setSeverity("error");
        setErrMsg("Incentive interval start date is required.");
        setOpen(true);
        return;
      }
    }

    setOpenCreateSalesIncentiveDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      product: campaign.campaign_type !== "DATA" ? selectedProduct : "ALL",
      incentive_type: incentiveType,
      title: incentiveTitle,
      time_interval: incentiveTimeframe,
      interval_type: incentiveIntervalType,
      cycle_time: incentiveIntervalTime,
      target: incentiveTarget,
      target_type: incentiveTargetType,
      reward: incentiveReward,
      is_commission_percentage: campaign.campaign_type !== "DATA" ? incentiveIsPercentage : false,
      start_date: incentiveStartDate,
      end_date: incentiveEndDate,
    };

    await axios
      .post("portal/campaigns/incentives/sales/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createPurchaseIncentive() {
    if (incentiveType === null) {
      setSeverity("error");
      setErrMsg("Incentive type is required.");
      setOpen(true);
      return;
    }
    if (incentiveTitle === null) {
      setSeverity("error");
      setErrMsg("Incentive name is required.");
      setOpen(true);
      return;
    }
    if (incentiveTimeframe === null) {
      setSeverity("error");
      setErrMsg("Incentive time interval is required.");
      setOpen(true);
      return;
    }
    if (incentivePurchaseTarget === null) {
      setSeverity("error");
      setErrMsg("Incentive target is required.");
      setOpen(true);
      return;
    }

    if (incentivePurchaseTargetType === null) {
      setSeverity("error");
      setErrMsg("Incentive target type is required.");
      setOpen(true);
      return;
    }

    if (incentiveReward === null) {
      setSeverity("error");
      setErrMsg("Incentive reward is required.");
      setOpen(true);
      return;
    }

    setOpenCreatePurchaseIncentiveDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      product: selectedProduct,
      incentive_type: incentiveType,
      title: incentiveTitle,
      time_interval: incentiveTimeframe,
      target: incentivePurchaseTarget,
      target_type: incentivePurchaseTargetType,
      reward: incentiveReward,
      is_commission_percentage: incentiveIsPercentage,
      start_date: incentiveStartDate,
    };

    await axios
      .post("portal/campaigns/incentives/purchase/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addApiEndpoint() {
    if (apiEndpointType === null) {
      setSeverity("error");
      setErrMsg("Select an endpoint type");
      setOpen(true);
      return;
    }

    if (apiEndpointUrl === null) {
      setSeverity("error");
      setErrMsg("Enter a valid endpoint URL");
      setOpen(true);
      return;
    }

    setOpenAddApiEndpointDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      endpoint_type: apiEndpointType,
      endpoint_url: apiEndpointUrl,
    };

    await axios
      .post("portal/api_endpoints/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachDataForm() {
    if (selectedDataForm === null) {
      setSeverity("error");
      setErrMsg("Select a data form");
      setOpen(true);
      return;
    }

    setOpenAttachDataFormDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      data_form: selectedDataForm,
    };

    await axios
      .post("portal/campaigns/data_form/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachCourse() {
    if (selectedCourse === null) {
      setSeverity("error");
      setErrMsg("Select a course");
      setOpen(true);
      return;
    }

    setOpenAttachCourseDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      course: selectedCourse,
    };

    await axios
      .post("portal/campaigns/courses/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachShippingRate() {
    if (selectedShippingRate === null) {
      setSeverity("error");
      setErrMsg("Select a shipping a collection");
      setOpen(true);
      return;
    }

    setOpenAttachShippingDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      collection: selectedShippingRate,
    };

    await axios
      .post("portal/campaigns/shipping_rates/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editCampaign() {
    if (title === null) {
      setSeverity("error");
      setErrMsg("Campaign title is required.");
      setOpen(true);
      return;
    }

    if (description === null) {
      setSeverity("error");
      setErrMsg("Campaign description is required.");
      setOpen(true);
      return;
    }

    if (customerUniqueness === null) {
      setSeverity("error");
      setErrMsg("Customer uniqueness required");
      setOpen(true);
      return;
    }

    if (paymentRequired !== null) {
      if (feeBearer === null) {
        setSeverity("error");
        setErrMsg("Fee bearer is required.");
        setOpen(true);
        return;
      }
    }

    if (dispenseCount < 1) {
      setDispenseCount(1);
    }

    setOpenEditCampaignDialog(false);
    setShowLoading(true);
    const json = {
      reference: campaign.reference,
      title: `${title}`,
      description: `${description}`,
      dispense_count: parseInt(dispenseCount, 10),
      payment_required: paymentRequired,
      fee_bearer: feeBearer,
      is_shipping_required: shippingRequired,
      enforce_location_capture: enforceLocationCapture,
      unique_customer: customerUniqueness,
    };

    await axios
      .post("portal/campaigns/modify.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("Unable to complete requested action");
        setOpen(true);
      });
  }

  async function createCampaignLocation() {
    if (locationTitle === null) {
      setSeverity("error");
      setErrMsg("A location name is required.");
      setOpen(true);
      return;
    }

    if (locationLat === null) {
      setSeverity("error");
      setErrMsg("Location latitude is required");
      setOpen(true);
      return;
    }

    if (locationLng === null) {
      setSeverity("error");
      setErrMsg("Location longitude is required");
      setOpen(true);
      return;
    }

    if (locationRad === null) {
      setSeverity("error");
      setErrMsg("Location area radius is required");
      setOpen(true);
      return;
    }

    if (parseInt(locationRad, 10) < 10) {
      setSeverity("error");
      setErrMsg("Location area radius is too restricted. A minimum of 10meters is required.");
      setOpen(true);
      return;
    }

    // if (enableAttendance) {
    //   if (attendanceHour === null) {
    //     setSeverity("error");
    //     setErrMsg("Please set an attendance time.");
    //     setOpen(true);
    //     return;
    //   }
    // }

    setOpenLocationDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      title: locationTitle,
      latitude: locationLat,
      longitude: locationLng,
      radius: parseInt(locationRad, 10),
      restrict_sales: restrictSalesToLocation,
      // attendance_enabled: enableAttendance,
      // attendance_hour: attendanceHour,
      // attendance_grace_period: attendanceGracePeriod,
      // attendance_photo_required: isPhotoAttendance,
    };

    await axios
      .post("portal/campaigns/locations/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function requestAgentCheckin() {
    if (parseInt(checkinGracePeriod, 10) < 10) {
      setSeverity("error");
      setErrMsg("Grace period is too short. A minimum of 10 minutes is required.");
      setOpen(true);
      return;
    }

    setOpenRequestCheckinDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedCampaignLocation,
      grace_period: parseInt(checkinGracePeriod, 10),
      verification_required: enforceFaceMatch,
    };

    await axios
      .post(`portal/campaigns/locations/${selectedCampaignLocation}/request/checkin.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function scheduleAgentCheckin() {
    if (parseInt(checkinGracePeriod, 10) < 10) {
      setSeverity("error");
      setErrMsg("Grace period is too short. A minimum of 10 minutes is required.");
      setOpen(true);
      return;
    }

    if (parseInt(locationCheckInTimeOfDay, 10) < 10) {
      setSeverity("error");
      setErrMsg("Please select a time of day for check-ins.");
      setOpen(true);
      return;
    }

    setOpenScheduleCheckinDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedCampaignLocation,
      grace_period: parseInt(checkinGracePeriod, 10),
      time: parseInt(locationCheckInTimeOfDay, 10),
      verification_required: enforceFaceMatch,
    };

    await axios
      .post(
        `portal/campaigns/locations/${selectedCampaignLocation}/request/checkin/schedule.json`,
        json
      )
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createCampaignViewAccess() {
    if (campaignViewEmail === null) {
      setSeverity("error");
      setErrMsg("Please enter a valid email address.");
      setOpen(true);
      return;
    }

    if (campaignViewAccessType === null) {
      setSeverity("error");
      setErrMsg("Please select an access type.");
      setOpen(true);
      return;
    }

    if (window.confirm("Are you sure you want to proceed with this action?") === false) {
      return;
    }

    setOpenCreateCampaignViewDialog(false);
    setShowLoading(true);
    const json = {
      campaign: campaign.reference,
      email_address: campaignViewEmail,
      access_type: campaignViewAccessType,
    };

    await axios
      .post(`portal/campaigns/windows/create.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createPresetAmount() {
    if (presetAmountTitle === null) {
      setSeverity("error");
      setErrMsg("Dispay name is required.");
      setOpen(true);
      return;
    }

    if (presetAmountType === null) {
      setSeverity("error");
      setErrMsg("Select an amount type.");
      setOpen(true);
      return;
    }

    if (presetAmountType === "FIXED") {
      if (parseInt(presetAmountAmt, 10) < 0) {
        setSeverity("error");
        setErrMsg("Fixed amount is invalid.");
        setOpen(true);
        return;
      }
    } else {
      if (presetAmountMin !== null) {
        if (parseInt(presetAmountMin, 10) <= 0) {
          setSeverity("error");
          setErrMsg("Invalid minimum amount entered.");
          setOpen(true);
          return;
        }
      }

      if (presetAmountMax !== null) {
        if (parseInt(presetAmountMax, 10) <= 0) {
          setSeverity("error");
          setErrMsg("Invalid maximum amount entered.");
          setOpen(true);
          return;
        }
      }
    }

    if (presetAmountFeeBearer === null) {
      setSeverity("error");
      setErrMsg("Select who bears the payment fees.");
      setOpen(true);
      return;
    }

    setOpenAddPresetAmountDialog(false);
    setShowLoading(true);

    const json = {
      campaign: campaign.reference,
      title: presetAmountTitle,
      amount_type: presetAmountType,
      fee_bearer: presetAmountFeeBearer,
      amount: presetAmountType === "FIXED" ? presetAmountAmt * 100 : presetAmountAmt,
      minimum_amount: presetAmountMin ? presetAmountMin * 100 : presetAmountMin,
      maximum_amount: presetAmountMax ? presetAmountMax * 100 : presetAmountMax,
    };

    await axios
      .post("portal/campaigns/preset_amounts/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    if (selectedPackageObject === null) {
      return;
    }
    if (selectedPackageObject.price === 0) {
      setPackageDuration(1);
    }
  }, [selectedPackageObject]);

  async function activateCampaign() {
    if (selectedPackage === null) {
      setSeverity("error");
      setErrMsg("Select a package");
      setOpen(true);
      return;
    }

    if (packageDuration === null) {
      setPackageDuration(1);
    }

    setOpenPackageDialog(false);
    setShowLoading(true);

    const json = {
      campaign: campaign.reference,
      package: selectedPackage,
      duration: packageDuration,
    };

    await axios
      .post("portal/campaigns/packages/purchase.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MessageDialog
        destinationType="campaign.agents"
        destinationKey={id}
        description="Send message to all campaign agents"
        displayState={showMessageComponentDialog}
        setDisplayState={setShowMessageComponentDialog}
      />
      <Snackbar
        autoHideDuration={5000}
        onClose={() => setOpenSnackBar(false)}
        open={openCopySnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Copied
        </Alert>
      </Snackbar>
      <Dialog open={openPackageDialog} fullWidth maxWidth="md">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6" fontSize={24}>
              Activate Campaign
            </MDTypography>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              Choose a subscription package
            </MDTypography>
          </MDBox>
          <MDBox>
            <Divider />
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Choose Package</InputLabel>
                      <Select
                        label="Choose Package"
                        onChange={(e) => {
                          let found = packages.every((pck) => {
                            if (pck.reference === e.target.value) {
                              setSelectedPackageObject(pck);
                              return false;
                            }
                            return true;
                          });
                          setSelectedPackage(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {packages.map((pckg) => (
                          <MenuItem value={pckg.reference}>{pckg.title}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                  <MDBox mt={5}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Duration</InputLabel>
                      <Select
                        label="Duration"
                        onChange={(e) => {
                          if (selectedPackageObject.price === 0) {
                            setPackageDuration(1);
                          } else {
                            setPackageDuration(e.target.value);
                          }
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        value={packageDuration}
                      >
                        {[1, 2, 3, 6, 9, 12].map((x) => (
                          <MenuItem value={x}>{`${x} month${x > 1 ? "s" : ""}`}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                  {selectedPackage && (
                    <MDBox mt={4}>
                      <Table>
                        <TableRow>
                          <TableCell>
                            <MDTypography fontSize={12}>Price</MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography align="right" fontSize={12}>
                              {`${currency}${(
                                (selectedPackageObject.price * packageDuration) /
                                100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography fontSize={12}>VAT</MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography align="right" fontSize={12}>
                              {`${currency}${(
                                (selectedPackageObject.price * packageDuration * 0.075) /
                                100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>
                            <MDTypography fontSize={14} fontWeight="bold">
                              Total
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography align="right" fontSize={14} fontWeight="bold">
                              {`${currency}${(
                                (selectedPackageObject.price * packageDuration * 0.075 +
                                  selectedPackageObject.price * packageDuration) /
                                100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                      </Table>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>
              <Grid item xs={0} md={1} lg={1}>
                <Divider orientation="vertical" flexItem />
              </Grid>
              <Grid item xs={12} md={5} lg={5}>
                <MDBox>
                  {selectedPackageObject ? (
                    <MDBox align="center">
                      <MDBox>
                        <MDTypography variant="h6">{selectedPackageObject.title}</MDTypography>
                        <MDTypography fontSize={14}>{`${currency}${(
                          selectedPackageObject.price / 100
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</MDTypography>
                      </MDBox>
                      <Divider />
                      {campaign.campaign_type === "SALES" && (
                        <MDBox mt={0}>
                          <Table>
                            <TableRow>
                              <TableCell>
                                <MDTypography>
                                  <MDTypography fontSize={12}>Sales Cap</MDTypography>
                                </MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {(
                                    selectedPackageObject.sales_cap * packageDuration
                                  ).toLocaleString("en", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography fontSize={12}>Overage Fee</MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {selectedPackageObject.is_sales_fee_percentage
                                    ? `${(selectedPackageObject.sales_fee * 100).toFixed(2)}%`
                                    : `${currency}${(
                                        selectedPackageObject.sales_fee / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {selectedPackageObject.is_sales_fee_percentage && (
                              <>
                                {selectedPackageObject.sales_fee_min && (
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography fontSize={12}>Fee (min)</MDTypography>
                                    </TableCell>
                                    <TableCell>
                                      <MDTypography align="right" fontSize={12}>{`${currency}${(
                                        selectedPackageObject.sales_fee_min / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}</MDTypography>
                                    </TableCell>
                                  </TableRow>
                                )}

                                {selectedPackageObject.sales_fee_max && (
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography fontSize={12}>Fee (max)</MDTypography>
                                    </TableCell>
                                    <TableCell>
                                      <MDTypography align="right" fontSize={12}>{`${currency}${(
                                        selectedPackageObject.sales_fee_max / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}</MDTypography>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </>
                            )}
                          </Table>
                        </MDBox>
                      )}

                      <MDBox mt={3}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Data Capture Cap</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {(selectedPackageObject.data_cap * packageDuration).toLocaleString(
                                  "en",
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  }
                                )}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Overage Fee</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>{`${currency}${(
                                selectedPackageObject.data_fee / 100
                              ).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>

                      {/* <MDBox mt={3}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Expires On</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {new Date(
                                  new Date().setDate(
                                    new Date().getDate() +
                                      packageDuration * selectedPackageObject.duration
                                  )
                                ).toISOString()}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox> */}
                      <MDBox mt={3}>
                        <Table>
                          <TableRow>
                            <TableCell>
                              <MDTypography fontSize={12}>Duration</MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography align="right" fontSize={12}>
                                {`${packageDuration * selectedPackageObject.duration} days`}
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </MDBox>
                      <MDBox mt={3}>
                        <Alert severity="info">
                          <MDTypography variant="h6" fontSize={12}>
                            Fees apply above package caps.
                          </MDTypography>
                        </Alert>
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox align="center">
                      <MDTypography variant="h6" fontSize={36}>
                        <Icon>error</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={14}>
                        No package selected
                      </MDTypography>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenPackageDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              activateCampaign();
            }}
          >
            Activate
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddPresetAmountDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Payment Amount</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                name="email"
                margin="dense"
                label="Display Name"
                placeholder="This will be displayed at data capture"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPresetAmountTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Amount Type</InputLabel>
                <Select
                  label="Amount Type"
                  onChange={(e) => {
                    setPresetAmountType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="FIXED">Fixed Amount</MenuItem>
                  <MenuItem value="VARIABLE">Any Amount</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {presetAmountType && (
              <MDBox>
                {presetAmountType === "FIXED" ? (
                  <MDBox mt={3}>
                    <MDInput
                      name="amount"
                      margin="dense"
                      label="Fixed Amount"
                      placeholder="Enter a fixed amount to collect."
                      type="number"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setPresetAmountAmt(e.target.value)}
                    />
                  </MDBox>
                ) : (
                  <MDBox mt={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox>
                          <MDInput
                            name="amount"
                            margin="dense"
                            label="Minimum Amount (Optional)"
                            type="number"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setPresetAmountMin(e.target.value)}
                          />
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} md={6} lg={6}>
                        <MDBox>
                          <MDInput
                            name="amount"
                            margin="dense"
                            label="Maximum Amount (Optional)"
                            type="number"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setPresetAmountMax(e.target.value)}
                          />
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                )}
              </MDBox>
            )}
            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Fee Bearer</InputLabel>
                <Select
                  label="Fee Bearer"
                  onChange={(e) => {
                    setPresetAmountFeeBearer(e.target.value);
                  }}
                  value={presetAmountFeeBearer}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="PAYER">Payer</MenuItem>
                  <MenuItem value="MERCHANT">Merchant (You)</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddPresetAmountDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createPresetAmount();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openCreateCampaignViewDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Share Campaign Access</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={0}>
              <MDInput
                name="email"
                margin="dense"
                label="Email Address"
                type="email"
                value={campaignViewEmail}
                fullWidth
                variant="outlined"
                onChange={(e) => setCampaignViewEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Access Type</InputLabel>
                <Select
                  label="Access Type"
                  onChange={(e) => {
                    setCampaignViewAccessType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  value={campaignViewAccessType}
                >
                  <MenuItem value="VIEW">View Only</MenuItem>
                  <MenuItem value="DOWNLOAD">View & Download</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3} px={1}>
              <MDTypography variant="body1" fontSize="small" justifyContent="space-evenly">
                A unique access link will be sent to the email address provided above.
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateCampaignViewDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createCampaignViewAccess();
            }}
          >
            Send Access
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openRequestCheckinDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Request Agent Check-In</MDBox>
          <MDBox mt={1}>
            <MDTypography variant="body1" fontSize="small">
              Prompt your agents to perform physical check-ins at this location
            </MDTypography>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <MDInput
                name="latitude"
                margin="dense"
                label="Grace Period (in minutes)"
                type="number"
                value={checkinGracePeriod}
                fullWidth
                variant="outlined"
                onChange={(e) => setCheckinGracePeriod(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={enforceFaceMatch}
                onChange={(e) => {
                  setEnforceFaceMatch(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enforce Face Match? (Requires verified agent accounts)
              </MDTypography>
            </MDBox>
            <MDBox mt={3} align="right" mb={3}>
              <MDButton
                size="small"
                color="dark"
                startIcon={<Icon>timer</Icon>}
                onClick={() => {
                  setOpenRequestCheckinDialog(false);
                  setOpenScheduleCheckinDialog(true);
                }}
                variant="outlined"
              >
                Want to schedule Check-In? Click here.
              </MDButton>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenRequestCheckinDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              requestAgentCheckin();
            }}
          >
            Request Check-In
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openScheduleCheckinDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Schedule Agent Check-In</MDBox>
          <MDBox mt={1}>
            <MDTypography variant="body1" fontSize="small">
              Schedule when your agents should perform physical check-ins at this location.
            </MDTypography>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Time Of Day</InputLabel>
                <Select
                  label="Time Of Day"
                  onChange={(e) => {
                    setLocationCheckInTimeOfDay(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="00">12 AM</MenuItem>
                  <MenuItem value="1">1 AM</MenuItem>
                  <MenuItem value="2">2 AM</MenuItem>
                  <MenuItem value="4">4 AM</MenuItem>
                  <MenuItem value="5">5 AM</MenuItem>
                  <MenuItem value="6">6 AM</MenuItem>
                  <MenuItem value="7">7 AM</MenuItem>
                  <MenuItem value="8">8 AM</MenuItem>
                  <MenuItem value="9">9 AM</MenuItem>
                  <MenuItem value="10">10 AM</MenuItem>
                  <MenuItem value="11">11 AM</MenuItem>
                  <MenuItem value="12">12 PM</MenuItem>
                  <MenuItem value="13">1 PM</MenuItem>
                  <MenuItem value="14">2 PM</MenuItem>
                  <MenuItem value="15">3 PM</MenuItem>
                  <MenuItem value="16">4 PM</MenuItem>
                  <MenuItem value="17">5 PM</MenuItem>
                  <MenuItem value="18">6 PM</MenuItem>
                  <MenuItem value="19">7 PM</MenuItem>
                  <MenuItem value="20">8 PM</MenuItem>
                  <MenuItem value="21">9 PM</MenuItem>
                  <MenuItem value="22">10 PM</MenuItem>
                  <MenuItem value="23">11 PM</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                name="grace_period"
                margin="dense"
                label="Grace Period (in minutes)"
                type="number"
                value={checkinGracePeriod}
                fullWidth
                variant="outlined"
                onChange={(e) => setCheckinGracePeriod(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={enforceFaceMatch}
                onChange={(e) => {
                  setEnforceFaceMatch(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enforce Face Match? (Requires verified agent accounts)
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenScheduleCheckinDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              scheduleAgentCheckin();
            }}
          >
            Schedule Check-In
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openLocationDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Create Location</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Location Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDBox>
                <GoogleAddressField
                  displayName="Search Address On Google Maps"
                  setAddress={() => {}}
                  setLatitude={setLocationLat}
                  setLongitude={setLocationLng}
                />
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                name="coverage_radius"
                margin="dense"
                label="Coverage Radius Around Location (in meters)"
                type="number"
                value={locationRad}
                fullWidth
                variant="outlined"
                onChange={(e) => setLocationRad(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3}>
              <MDTypography variant="h6" fontWeight="regular">
                Advanced Options
              </MDTypography>
            </MDBox>
            <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={restrictSalesToLocation}
                onChange={(e) => {
                  setRestrictSalesToLocation(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enforce Sales Geo-Fencing? (Restricts sales within location radius)
              </MDTypography>
            </MDBox>
            {/* <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={enableAttendance}
                onChange={(e) => {
                  setEnableAttendance(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enable Attendance
              </MDTypography>
            </MDBox>
            {enableAttendance && (
              <MDBox>
                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox>
                        <FormControl fullWidth>
                          <InputLabel>Attendance Time</InputLabel>
                          <Select
                            label="Attendance Time"
                            onChange={(e) => {
                              setAttendanceHour(e.target.value);
                            }}
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                            value={attendanceHour}
                          >
                            {scheduleTimes.map((row) => (
                              <MenuItem value={row}>{row}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <MDBox mt={-1}>
                        <MDInput
                          name="attendance_grace_period"
                          margin="dense"
                          label="Grace Period (Minutes)"
                          type="number"
                          value={attendanceGracePeriod}
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setAttendanceGracePeriod(e.target.value)}
                        />
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={isPhotoAttendance}
                    onChange={(e) => {
                      setIsPhotoAttendance(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Enforce attendance face bio-metric check?
                  </MDTypography>
                </MDBox>
              </MDBox>
            )} */}

            {/* <MDBox mt={2}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    name="latitude"
                    margin="dense"
                    label="GPS Latitude"
                    type="text"
                    value={locationLat}
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setLocationLat(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    name="longitude"
                    margin="dense"
                    label="GPS Longitude"
                    value={locationLng}
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setLocationLng(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox> */}

            {centerLocation !== null && (
              <MDBox mt={5} mb={3}>
                <div style={{ height: "50vh", width: "100%" }}>
                  <MDBox>
                    <MapPicker
                      defaultLocation={centerLocation}
                      zoom={18}
                      mapTypeId="roadmap"
                      style={{ height: "50vh" }}
                      onChangeLocation={(lat, lng) => {
                        onLocationPicked(lat, lng);
                      }}
                      apiKey={AppConfig.google_map_key}
                    />
                  </MDBox>
                </div>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenLocationDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              createCampaignLocation();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditCampaignDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Campaign</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                placeholder="E.g Chicken Republic Deal"
                name="title"
                value={title}
                margin="dense"
                label="Campaign Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <Editor
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter a meaningful description..."
              />
            </MDBox>

            {campaign.campaign_type !== "DATA" && (
              <>
                <MDBox mt={3}>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Customer Uniqueness</InputLabel>
                    <Select
                      label="Customer Uniqueness"
                      value={customerUniqueness}
                      onChange={(e) => {
                        setCustomerUniqueness(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      <MenuItem value="CAMPAIGN">Unique to Campaign</MenuItem>
                      <MenuItem value="ACCOUNT">Unique to Account</MenuItem>
                      <MenuItem value="OPEN">Open to Anyone</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={paymentRequired}
                    onChange={(e) => {
                      setPaymentRequired(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Payment Required?
                  </MDTypography>
                </MDBox>
                {paymentRequired && (
                  <MDBox mt={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Fee Bearer</InputLabel>
                      <Select
                        label="Fee Bearer"
                        value={feeBearer}
                        onChange={(e) => {
                          setFeeBearer(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        <MenuItem value="MERCHANT">Merchant (You)</MenuItem>
                        <MenuItem value="PAYER">Payer (Customer)</MenuItem>
                      </Select>
                    </FormControl>
                  </MDBox>
                )}
                <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={shippingRequired}
                    onChange={(e) => {
                      setShippingRequired(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Shipping Required?
                  </MDTypography>
                </MDBox>
              </>
            )}
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={enforceLocationCapture}
                onChange={(e) => {
                  setEnforceLocationCapture(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enforce GPS Location Capture?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditCampaignDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            onClick={() => {
              editCampaign();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachShippingDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Shipping Fees</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Shipping Fees</InputLabel>
                <Select
                  label="Shipping Fees"
                  onChange={(e) => {
                    setSelectedShippingRate(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    shippingRates.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      shippingRates.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachShippingDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              attachShippingRate();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachDataFormDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Data Form</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Data Form</InputLabel>
                <Select
                  label="Data Form"
                  onChange={(e) => {
                    setSelectedDataForm(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataForms.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataForms.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachDataFormDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              attachDataForm();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachCourseialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Course</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Course</InputLabel>
                <Select
                  label="Course"
                  onChange={(e) => {
                    setSelectedCourse(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    accountCourses.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      accountCourses.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachCourseDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              attachCourse();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewProductDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Product</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Product</InputLabel>
                <Select
                  label="Select Product"
                  onChange={(e) => {
                    setSelectedProduct(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {/* <MenuItem value="1">Jump Suit</MenuItem> */}
                  {
                    // --> Notice below changes
                    accountProducts.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      accountProducts.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                value={attachProductQty}
                margin="dense"
                label="Item Quantity"
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => setAttachProductQty(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Order Restriction</InputLabel>
                <Select
                  label="Order Restriction"
                  onChange={(e) => {
                    if (e.target.value === "SINGLE") {
                      setProductMaxOrderQty(1);
                    }
                    setProductRestriction(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="SINGLE">Single</MenuItem>
                  <MenuItem value="MULTIPLE">Multiple</MenuItem>
                </Select>
              </FormControl>
              <MDTypography mt={1} variant="subtitle2" color="info" pl={1} fontSize={14}>
                <small>
                  <Icon>info</Icon>&nbsp;
                  <b>Single</b>: Customer can only purchase one product, one quantity per sale
                  <br />
                  &nbsp;&nbsp;&nbsp;<b>Multiple</b>: Customer can add product multiple times with
                  different quantities.
                </small>
              </MDTypography>
            </MDBox>
            {productRestriction === "MULTIPLE" && (
              <MDBox mt={3}>
                <MDInput
                  value={productMaxOrderQty}
                  name="productDispenseQty"
                  margin="dense"
                  label="Max Quantity Per Sale"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setProductMaxOrderQty(e.target.value)}
                />
                <MDTypography mt={1} variant="subtitle2" color="info" pl={1} fontSize={14}>
                  <small>
                    <Icon>info</Icon>&nbsp;Maximum quantity allowed per selection. Set to zero to
                    allow any quantity.
                  </small>
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewProductDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createProduct();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditProductDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Product</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                value={productTitle}
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setProductTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={5}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Product Pricing</InputLabel>
                <Select
                  value={isProductPriceFixed ? "FIXED" : "OPEN"}
                  label="Product Pricing"
                  onChange={(e) => {
                    let xtt = true;
                    if (e.target.value === "FIXED") {
                      xtt = true;
                    } else {
                      xtt = false;
                    }
                    setIsProductPriceFixed(xtt);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="FIXED">Fixed amount</MenuItem>
                  <MenuItem value="OPEN">Allow any amount</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {isProductPriceFixed ? (
              <MDBox mt={3}>
                <MDInput
                  value={productAmount}
                  name="price"
                  margin="dense"
                  label="Price"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setProductAmount(e.target.value)}
                />
              </MDBox>
            ) : (
              <>
                <MDBox mt={3}>
                  <MDInput
                    value={productPriceMinimum}
                    name="price"
                    margin="dense"
                    label="Minimum Price"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setProductPriceMinimum(e.target.value)}
                  />
                </MDBox>
                <MDBox mt={2}>
                  <MDInput
                    value={productPriceMaximum}
                    name="price"
                    margin="dense"
                    label="Maximum Price"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setProductPriceMaximum(e.target.value)}
                  />
                </MDBox>
              </>
            )}

            <MDBox mt={5}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Order Restriction</InputLabel>
                <Select
                  value={productRestriction}
                  label="Order Restriction"
                  onChange={(e) => {
                    if (e.target.value === "SINGLE") {
                      setProductMaxOrderQty(1);
                    }
                    setProductRestriction(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="SINGLE">Single</MenuItem>
                  <MenuItem value="MULTIPLE">Multiple</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {productRestriction === "MULTIPLE" ? (
              <MDBox mt={3}>
                <MDInput
                  value={productMaxOrderQty}
                  name="productDispenseQty"
                  margin="dense"
                  label="Max Quantity Per Sale"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setProductMaxOrderQty(e.target.value)}
                />
                <br />
                <MDTypography variant="text" color="info" pl={1} fontSize="small">
                  <small>
                    <Icon>info</Icon>&nbsp;Maximum quantity allowed per selection. Set to zero to
                    allow any quantity.
                  </small>
                </MDTypography>
              </MDBox>
            ) : (
              <> </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditProductDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editProduct();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      {meta ? (
        <Dialog open={openAddApiEndpointDialog} fullWidth maxWidth="xs">
          <DialogTitle>
            <MDBox>Configure API Endpoint</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={2} mb={3}>
              <MDBox mt={2}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Endpoint Type</InputLabel>
                  <Select
                    label="Endpoint Type"
                    onChange={(e) => {
                      setApiEndpointType(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {/* <MenuItem value="1">Jump Suit</MenuItem> */}
                    {
                      // --> Notice below changes
                      meta.api_endpoint_types.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        meta.api_endpoint_types.map((record) => (
                          <MenuItem value={record.value}>{record.name}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={4}>
                <MDInput
                  placeholder="Ex. https://example.com/api/pushService"
                  multiline
                  rows={4}
                  name="content"
                  margin="dense"
                  label="Endpoint Url"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setApiEndpointUrl(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenAddApiEndpointDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Cancel
            </MDButton>
            <MDButton
              color="info"
              variant="outlined"
              onClick={() => {
                addApiEndpoint();
              }}
            >
              Save Endpoint
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}

      <Dialog open={openUploadMaterialDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Material</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setMaterialTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Material Type</InputLabel>
                <Select
                  label="Material Type"
                  onChange={(e) => {
                    setMaterialDocType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="IMAGE">Image</MenuItem>
                  <MenuItem value="PDF">PDF</MenuItem>
                  <MenuItem value="WORD">Word Document</MenuItem>
                  <MenuItem value="EXCEL">Excel Sheet</MenuItem>
                  {/* <MenuItem value="TEXT">Text</MenuItem> */}
                  <MenuItem value="LINK">External Link</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {materialDocType !== null ? (
              <div>
                {materialDocType !== "LINK" ? (
                  <MDBox mt={4}>
                    <TextField
                      type="file"
                      name="upload_file"
                      id="upload_file"
                      // onChange={handleFileInputChange}
                      onChange={(e) => fileSelected(e, true)}
                    />
                  </MDBox>
                ) : (
                  <MDBox mt={4}>
                    <MDInput
                      placeholder="Ex. https://youtube.com"
                      multiline
                      rows={4}
                      name="content"
                      margin="dense"
                      label="Link"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setMaterialContent(e.target.value)}
                    />
                  </MDBox>
                )}
              </div>
            ) : (
              <> </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadMaterialDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadMaterial();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadAgentsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Agents</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2} pl={3} alignContents="center">
              <a
                href={`${AppConfig.api_media_url}documents/templates/agent_upload_template.csv`}
                target="_blank"
                rel="noreferrer"
              >
                == Sample Template ==
              </a>
            </MDBox>
            <Divider />
            <MDBox mt={2}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadAgentsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadAgents();
            }}
          >
            Upload Agents
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewSuperAgentDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Agent Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group</InputLabel>
                <Select
                  label="Agent Group"
                  onChange={(e) => {
                    setSelectedAgentGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      agentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>
                          {record.agent_group.title}
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewSuperAgentDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createSuperAgent();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddAggregatorDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Supervisor</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Supervisor</InputLabel>
                <Select
                  label="Supervisor"
                  onChange={(e) => {
                    setSelectedAggregator(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    aggregators.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      aggregators.map((row) => (
                        <MenuItem value={`${row.reference}`}>{row.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Agent Quota (Optional)"
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => setAggregatorQuota(e.target.value)}
              />
              <MDBox mt={1}>
                <Alert severity="info">
                  <MDTypography fontSize={11}>
                    Set how many agents this supervisor can assign to your campaign. Leave blank for
                    an unlimited number.
                  </MDTypography>
                </Alert>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddAggregatorDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              assignAggregator();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      {meta ? (
        <Dialog open={openProductItemTransfer} minWidth="xs" fullWidth>
          <DialogTitle>
            <MDBox>Transfer Product Items</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={2} mb={3}>
              <MDBox mt={2}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Product</InputLabel>
                  <Select
                    label="Select Product"
                    onChange={(e) => {
                      setSelectedProductTransfer(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      productsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        productsRaw.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={3}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Destination Campaign</InputLabel>
                  <Select
                    label="Destination Campaign"
                    onChange={(e) => {
                      getDestinationCampaignProducts(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      meta.campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        meta.campaigns.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={3}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Destination Campaign Product</InputLabel>
                  <Select
                    label="Destination Campaign Product"
                    onChange={(e) => {
                      setSelectedDestionationProductTransfer(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      destinationCampaignProducts.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        destinationCampaignProducts.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={2}>
                <MDInput
                  value={transferQty}
                  name="title"
                  margin="dense"
                  label="Quantity"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setTransferQty(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenProductItemTransferDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              Cancel
            </MDButton>
            <MDButton
              color="info"
              variant="contained"
              onClick={() => {
                transferProductObjects();
              }}
            >
              Transfer
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <Dialog open={openCreateSalesCommissionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Sales Commission</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            {campaign.campaign_type !== "DATA" && (
              <MDBox mt={2}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Product</InputLabel>
                  <Select
                    label="Select Product"
                    onChange={(e) => {
                      setSelectedProduct(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value="ALL">All Products</MenuItem>
                    {
                      // --> Notice below changes
                      productsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        productsRaw.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}

            {/* <MDBox mt={3}>
              <FormControlLabel
                control={
                  <Switch
                    color="success"
                    checked={salesCommissionPercentage}
                    onChange={() => setSalesCommissionPercentage(!salesCommissionPercentage)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Is commission a percentage?"
                labelPlacement="start"
              />
            </MDBox> */}
            {campaign.campaign_type !== "DATA" ? (
              <MDBox>
                <MDBox mt={3}>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Commission Type</InputLabel>
                    <Select
                      label="Commission Type"
                      onChange={(e) => {
                        let val = true;
                        if (e.target.value === "FIXED") {
                          val = false;
                        }
                        setSalesCommissionPercentage(val);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      <MenuItem value="FIXED">Fixed Amount</MenuItem>
                      <MenuItem value="PERCENTAGE">Percentage of Accrued Commission</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                {salesCommissionPercentage !== null && (
                  <MDBox mt={2}>
                    <MDInput
                      value={salesCommission}
                      name="title"
                      margin="dense"
                      label={salesCommissionPercentage ? "% Commission" : "Commission Amount"}
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setSalesCommission(e.target.value)}
                    />
                  </MDBox>
                )}
              </MDBox>
            ) : (
              // <MDBox display="flex" alignItems="center" ml={-1} mt={1}>
              //   <Checkbox
              //     checked={salesCommissionPercentage}
              //     onChange={() => setSalesCommissionPercentage(!salesCommissionPercentage)}
              //   />
              //   <MDTypography
              //     variant="button"
              //     fontWeight="regular"
              //     color="text"
              //     sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              //   >
              //     &nbsp;&nbsp;Is percentage of amount sold?
              //   </MDTypography>
              // </MDBox>
              <MDBox mt={2}>
                <MDInput
                  value={salesCommission}
                  name="title"
                  margin="dense"
                  label="Commission Amount"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setSalesCommission(e.target.value)}
                />
              </MDBox>
            )}
            <MDBox display="flex" alignItems="center" ml={-1} mt={2}>
              <Checkbox
                checked={salesCommissionSettlement}
                onChange={() => setSalesCommissionSettlement(!salesCommissionSettlement)}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Enable instant settlement?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateSalesCommissionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              createCommission();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openCreateSalesIncentiveDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Sales Incentive</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            {campaign.campaign_type !== "DATA" && (
              <MDBox mt={2}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Product</InputLabel>
                  <Select
                    label="Select Product"
                    onChange={(e) => {
                      setSelectedProduct(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value="ALL">All Products</MenuItem>
                    {
                      // --> Notice below changes
                      productsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        productsRaw.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}
            <MDBox mt={2}>
              <MDInput
                value={incentiveTitle}
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentiveTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Target Type</InputLabel>
                <Select
                  label="Target Type"
                  onChange={(e) => {
                    setIncentiveTargetType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="COUNT">
                    Count (Number of {campaign.campaign_type !== "DATA" ? "Sales" : "Captures"})
                  </MenuItem>
                  {campaign.campaign_type !== "DATA" && (
                    <MenuItem value="VOLUME">Volume (Volume of Sales)</MenuItem>
                  )}
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={incentiveTarget}
                name="title"
                margin="dense"
                label={
                  incentiveTargetType === "COUNT"
                    ? `Number of ${campaign.campaign_type !== "DATA" ? "Sales" : "Captures"}`
                    : "Sales Volume"
                }
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentiveTarget(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Reward Type</InputLabel>
                <Select
                  label="Reward Type"
                  onChange={(e) => {
                    setIncentiveReward(null);
                    setIncentiveType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="CASH">Cash</MenuItem>
                  <MenuItem value="AIRTIME">Airtime</MenuItem>
                  <MenuItem value="DATA">Data Bundle</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {incentiveType !== null ? (
              <MDBox>
                {incentiveType === "CASH" || incentiveType === "AIRTIME" ? (
                  <MDBox>
                    {campaign.campaign_type !== "DATA" && (
                      <MDBox mt={3}>
                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                          <InputLabel>Incentive Type</InputLabel>
                          <Select
                            label="Incentive Type"
                            onChange={(e) => {
                              let val = true;
                              if (e.target.value === "FIXED") {
                                val = false;
                              }
                              setIncentiveIsPercentage(val);
                            }}
                            sx={{ padding: "12px", paddingLeft: "3px" }}
                          >
                            <MenuItem value="FIXED">Fixed Amount</MenuItem>
                            <MenuItem value="PERCENTAGE">Percentage of Accrued Commission</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                      // <MDBox display="flex" alignItems="center" ml={-1} mt={1}>
                      //   <Checkbox
                      //     checked={incentiveIsPercentage}
                      //     onChange={() => setIncentiveIsPercentage(!incentiveIsPercentage)}
                      //   />
                      //   <MDTypography
                      //     variant="button"
                      //     fontWeight="regular"
                      //     color="text"
                      //     sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                      //   >
                      //     &nbsp;&nbsp;Reward a percentage of accrued commissions?
                      //   </MDTypography>
                      // </MDBox>
                    )}
                    <MDBox mt={2}>
                      <MDInput
                        value={incentiveReward}
                        name="title"
                        margin="dense"
                        label={incentiveIsPercentage ? "Incentive Percentage" : "Incentive Amount"}
                        type="decimal"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setIncentiveReward(e.target.value)}
                      />
                    </MDBox>
                  </MDBox>
                ) : (
                  <MDBox mt={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Data Bundle</InputLabel>
                      <Select
                        label="Data Bundle"
                        onChange={(e) => {
                          setIncentiveReward(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {
                          // --> Notice below changes
                          incentiveDataBundles.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            incentiveDataBundles.map((record) => (
                              <MenuItem value={record.code}>
                                {record.title} (N{record.price / 100})
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                )}
              </MDBox>
            ) : (
              <> </>
            )}
            <MDBox mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Interval Type</InputLabel>
                      <Select
                        label="Interval Type"
                        onChange={(e) => {
                          setIncentiveIntervalType(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        <MenuItem value="ROLLING">Rolling</MenuItem>
                        <MenuItem value="CYCLE">Cycle</MenuItem>
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    value={incentiveTimeframe}
                    name="title"
                    margin="dense"
                    label="Time Interval (Days)"
                    type="number"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setIncentiveTimeframe(e.target.value)}
                  />
                </Grid>
              </Grid>
            </MDBox>
            {incentiveIntervalType && (
              <MDBox>
                {incentiveIntervalType === "CYCLE" && (
                  <MDBox>
                    <MDBox mt={3}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Cycle Time</InputLabel>
                        <Select
                          label="Cycle Time"
                          onChange={(e) => {
                            setIncentiveIntervalTime(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                        >
                          {
                            // --> Notice below changes
                            incentiveIntervalTimes.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              incentiveIntervalTimes.map((record) => (
                                <MenuItem value={record.value}>{record.name}</MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            )}
            <MDBox mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    value={incentiveStartDate}
                    name="title"
                    margin="dense"
                    label="Start Date (Optional)"
                    type="date"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setIncentiveStartDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDInput
                    value={incentiveEndDate}
                    name="title"
                    margin="dense"
                    label="End Date (Optional)"
                    type="date"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setIncentiveEndDate(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateSalesIncentiveDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              createSalesIncentive();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openCreatePurchaseIncentiveDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Purchase Incentive</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            {campaign.campaign_type !== "DATA" && (
              <MDBox mt={2}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Product</InputLabel>
                  <Select
                    label="Select Product"
                    onChange={(e) => {
                      setSelectedProduct(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    <MenuItem value="ALL">All Products</MenuItem>
                    {
                      // --> Notice below changes
                      productsRaw.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        productsRaw.map((record) => (
                          <MenuItem value={record.reference}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}

            <MDBox mt={2}>
              <MDInput
                value={incentiveTitle}
                name="title"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentiveTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={incentiveTimeframe}
                name="title"
                margin="dense"
                label="Time Interval (Days)"
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentiveTimeframe(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Target Type</InputLabel>
                <Select
                  label="Target Type"
                  onChange={(e) => {
                    setIncentivePurchaseTargetType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="COUNT">Count (Number of Purchase)</MenuItem>
                  {campaign.campaign_type !== "DATA" ? (
                    <MenuItem value="VOLUME">Volume (Volume of Purchases)</MenuItem>
                  ) : (
                    <> </>
                  )}
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={incentivePurchaseTarget}
                name="title"
                margin="dense"
                label={
                  incentivePurchaseTargetType === "COUNT"
                    ? "Number of Purchases"
                    : "Purchase Volume"
                }
                type="number"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentivePurchaseTarget(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Reward Type</InputLabel>
                <Select
                  label="Reward Type"
                  onChange={(e) => {
                    setIncentiveReward(null);
                    setIncentiveType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="AIRTIME">Airtime</MenuItem>
                  <MenuItem value="DATA">Data Bundle</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            {incentiveType !== null ? (
              <MDBox>
                {incentiveType === "CASH" || incentiveType === "AIRTIME" ? (
                  <>
                    <MDBox mt={2}>
                      <MDInput
                        value={incentiveReward}
                        name="title"
                        margin="dense"
                        label="Reward"
                        type="decimal"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setIncentiveReward(e.target.value)}
                      />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" ml={-1} mt={1}>
                      <Checkbox
                        checked={incentiveIsPercentage}
                        onChange={() => setIncentiveIsPercentage(!incentiveIsPercentage)}
                      />
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                      >
                        &nbsp;&nbsp;Is percentage of amount purchased?
                      </MDTypography>
                    </MDBox>
                  </>
                ) : (
                  <MDBox mt={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Data Bundle</InputLabel>
                      <Select
                        label="Data Bundle"
                        onChange={(e) => {
                          setIncentiveReward(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {
                          // --> Notice below changes
                          incentiveDataBundles.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            incentiveDataBundles.map((record) => (
                              <MenuItem value={record.code}>
                                {record.title} (N{record.price / 100})
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                )}
              </MDBox>
            ) : (
              <> </>
            )}
            <MDBox mt={3}>
              <MDInput
                value={incentiveStartDate}
                name="title"
                margin="dense"
                label="Start Date (Optional)"
                type="date"
                fullWidth
                variant="outlined"
                onChange={(e) => setIncentiveStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreatePurchaseIncentiveDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="contained"
            onClick={() => {
              createPurchaseIncentive();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      {pageLoaded && (
        <MDBox pt={2} pb={3}>
          <MDBox mt={0} mb={2} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/campaigns`);
                }}
              >
                Back
              </Button>
            </MDBox>
            {campaign.campaign_type === "DATA" ? (
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    navigate(`/data-captures/overview/${id}`);
                  }}
                  startIcon={<Icon>insights</Icon>}
                >
                  Insights
                </Button>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    navigate(`/data-captures/${id}`);
                  }}
                  startIcon={<Icon>list</Icon>}
                >
                  Records
                </Button>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    const downloadUrl = `${AppConfig.api_base_url}campaigns/reports/${campaign.reference}/${accountInfo.user.reference}`;
                    window.open(downloadUrl, "_blank");
                  }}
                  startIcon={<Icon>download</Icon>}
                >
                  Report
                </Button>
              </MDBox>
            ) : (
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    navigate(`/campaigns/${id}`);
                  }}
                  startIcon={<Icon>insights</Icon>}
                >
                  Insights
                </Button>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    if (campaign.campaign_type !== "DATA") {
                      navigate(`/campaigns/${id}/sales`);
                    }
                  }}
                  startIcon={<Icon>list</Icon>}
                >
                  Sales
                </Button>
                <Button
                  color="dark"
                  size="small"
                  onClick={() => {
                    const downloadUrl = `${AppConfig.api_base_url}campaigns/reports/${campaign.reference}/${accountInfo.user.reference}`;
                    window.open(downloadUrl, "_blank");
                  }}
                  startIcon={<Icon>download</Icon>}
                >
                  Report
                </Button>
              </MDBox>
            )}
          </MDBox>
          <MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox>
                      <MDBox p={2}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} md={6} lg={6}>
                            <MDTypography
                              variant="h6"
                              fontWeight="medium"
                              textTransform="capitalize"
                            >
                              Campaign Information
                            </MDTypography>
                          </Grid>
                          {/* {campaign.campaign_type !== "DATA" ? (
                        <Grid item xs={6} md={6} lg={6}>
                          <MDBox align="right">
                            <MDButton
                              variant="outlined"
                              color="warning"
                              size="small"
                              onClick={() => {
                                setOpenEditCampaignDialog(true);
                              }}
                              startIcon={<Icon sx={{ fontWeight: "bold" }}>edit</Icon>}
                            >
                              Edit
                            </MDButton>
                          </MDBox>
                        </Grid>
                      ) : (
                        <> </>
                      )} */}
                          <Grid item xs={6} md={6} lg={6}>
                            <MDBox align="right">
                              <Tooltip title={`${campaign.status ? "Disable" : "Enable"} Campaign`}>
                                <MDButton
                                  variant="outlined"
                                  color={campaign.status ? "info" : "dark"}
                                  size="small"
                                  onClick={() => {
                                    updateStatus();
                                  }}
                                  iconOnly
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>
                                    {campaign.status ? "pause" : "play_arrow"}
                                  </Icon>
                                </MDButton>
                              </Tooltip>
                              &nbsp;
                              <Tooltip title="Edit Campaign">
                                <MDButton
                                  variant="outlined"
                                  color="warning"
                                  size="small"
                                  onClick={() => {
                                    setOpenEditCampaignDialog(true);
                                  }}
                                  iconOnly
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                                </MDButton>
                              </Tooltip>
                              &nbsp;
                              <Tooltip title="Delete Campaign">
                                <MDButton
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => {
                                    if (window.confirm("Delete campaign?") === false) {
                                      return;
                                    }

                                    deleteCampaign();
                                  }}
                                  iconOnly
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                                </MDButton>
                              </Tooltip>
                            </MDBox>
                          </Grid>
                        </Grid>
                      </MDBox>
                      <TableContainer component={Paper}>
                        <Table aria-label="campaign information">
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Reference
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {campaign.reference}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Name
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {campaign.title}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Description
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  <div dangerouslySetInnerHTML={{ __html: campaign.description }} />
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Campaign Type
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {campaign.campaign_type}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {campaign.campaign_type !== "DATA" ? (
                              <TableRow>
                                <TableCell>
                                  <MDTypography variant="h6" fontWeight="medium">
                                    Unique Customer
                                  </MDTypography>
                                </TableCell>
                                <TableCell align="right">
                                  <MDTypography variant="h6" fontWeight="light">
                                    {campaign.unique_customer}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            ) : (
                              <> </>
                            )}
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Date Added
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {campaign.created}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox mt={0}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox>
                      <TableContainer component={Paper}>
                        <Table aria-label="campaign information">
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="light">
                                  <b>
                                    {campaign.campaign_type !== "DATA"
                                      ? "Payment Link"
                                      : "Web Link"}
                                  </b>
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDBox
                                  ml={-1}
                                  mt={0}
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="start"
                                >
                                  <a href={campaign.web_link} target="_blank" rel="noreferrer">
                                    <IconButton variant="outlined" color="dark">
                                      <Icon>send</Icon>
                                    </IconButton>
                                  </a>
                                  <IconButton
                                    variant="outlined"
                                    color="info"
                                    onClick={() => copy(campaign.web_link)}
                                  >
                                    <Icon>copy</Icon>
                                  </IconButton>
                                  <IconButton onClick={() => shareLink("whatsapp", campaign)}>
                                    <WhatsAppIcon color="success">WhatsApp</WhatsAppIcon>
                                  </IconButton>
                                  <IconButton onClick={() => shareLink("telegram", campaign)}>
                                    <Icon color="info">telegram</Icon>
                                  </IconButton>
                                  <IconButton onClick={() => shareWebCampaign(campaign)}>
                                    <Icon color="dark">share</Icon>
                                  </IconButton>
                                </MDBox>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MDBox>
                  </Card>
                </MDBox>

                <MDBox mt={3}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox>
                      <TableContainer component={Paper}>
                        <Table aria-label="campaign information">
                          <TableBody>
                            {campaign.campaign_type !== "DATA" && (
                              <>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="medium">
                                      Payment Required
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {campaign.payment_required ? "YES" : "NO"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                {campaign.payment_required ? (
                                  <TableRow>
                                    <TableCell>
                                      <MDTypography variant="h6" fontWeight="medium">
                                        Fee Bearer
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="light">
                                        {campaign.fee_bearer}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  <> </>
                                )}
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="medium">
                                      Shipping Enabled
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {campaign.is_shipping_required ? "YES" : "NO"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </>
                            )}

                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Agents
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDBox sx={{ width: "100%" }}>
                                  <MDBox>
                                    <MDTypography variant="h6" fontSize={18} fontWeight="medium">
                                      {agentCount}
                                    </MDTypography>
                                  </MDBox>
                                  <Divider />
                                  <MDBox sx={{ width: "100%" }}>
                                    <MDButton
                                      variant="outlined"
                                      color="dark"
                                      size="small"
                                      iconOnly
                                      onClick={() => {
                                        setOpenUploadAgentsDialog(true);
                                      }}
                                    >
                                      <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                                    </MDButton>
                                    &nbsp;
                                    {agentCount > 0 && (
                                      <MDButton
                                        variant="outlined"
                                        color="warning"
                                        iconOnly
                                        size="small"
                                        onClick={() => {
                                          setShowMessageComponentDialog(true);
                                        }}
                                      >
                                        <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
                                      </MDButton>
                                    )}
                                  </MDBox>
                                </MDBox>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Agent Join Link
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDBox
                                  ml={-1}
                                  mt={0}
                                  display="flex"
                                  justifyContent="end"
                                  alignItems="end"
                                >
                                  <a href={campaign.join_link} target="_blank" rel="noreferrer">
                                    <IconButton variant="outlined" color="dark">
                                      <Icon>send</Icon>
                                    </IconButton>
                                  </a>
                                  <IconButton
                                    variant="outlined"
                                    color="info"
                                    onClick={() => copy(campaign.join_link)}
                                  >
                                    <Icon>copy</Icon>
                                  </IconButton>
                                </MDBox>
                              </TableCell>
                            </TableRow>
                            {/* <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="medium">
                                Status
                              </MDTypography>
                            </TableCell>
                            <TableCell align="right">
                              <MDBox>
                                <Switch
                                  color={campaign.status ? "success" : "error"}
                                  checked={campaign.status}
                                  onChange={() => updateStatus()}
                                  // inputProps={{ "aria-label": "controlled" }}
                                />
                              </MDBox>
                            </TableCell>
                          </TableRow> */}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          {accountInfo.account.plan.code === "PAG" && (
            <MDBox mt={3} mb={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  {/* <MDBox>
                    <MDTypography variant="h6" fontWeight="medium">
                      Campaign Package
                    </MDTypography>
                  </MDBox> */}
                  <MDBox mt={0} align="center">
                    {campaignPackage ? (
                      <MDBox>
                        {campaignPackage.is_active ? (
                          <MDBox mb={3}>
                            <MDTypography variant="h6" fontSize={48}>
                              <Icon color="success">check_circle</Icon>
                            </MDTypography>
                            <MDTypography variant="h6" fontSize={14} fontWeight="light">
                              Campaign is active
                            </MDTypography>
                          </MDBox>
                        ) : (
                          <MDBox mb={3}>
                            <MDTypography variant="h6" fontSize={48}>
                              <Icon color="error">error</Icon>
                            </MDTypography>
                            <MDTypography variant="h6" fontSize={14} fontWeight="light">
                              Active package has expired
                            </MDTypography>
                          </MDBox>
                        )}
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                  Data Capture Cap
                                </MDTypography>
                              </TableCell>
                              <TableCell align="center">
                                <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                  Data Overage Fee
                                </MDTypography>
                              </TableCell>
                              {campaign.campaign_type === "SALES" && (
                                <>
                                  <TableCell align="center">
                                    <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                      Sales Cap
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                      Sales Overage Fee
                                    </MDTypography>
                                  </TableCell>
                                </>
                              )}
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                  Expires On
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                  {`${campaignPackage.data_cap.toLocaleString("en", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })}`}
                                </MDTypography>
                              </TableCell>
                              <TableCell align="center">
                                <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                  {`${currency}${(campaignPackage.data_fee / 100).toLocaleString(
                                    "en",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}`}
                                </MDTypography>
                              </TableCell>
                              {campaign.campaign_type === "SALES" && (
                                <>
                                  <TableCell align="center">
                                    <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                      {`${campaignPackage.sales_cap.toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                      })}`}
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="center">
                                    {campaignPackage.is_sales_fee_percentage ? (
                                      <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                        {`${(campaignPackage.sales_fee * 100).toFixed(2)}%`}
                                      </MDTypography>
                                    ) : (
                                      <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                        {`${currency}${(
                                          campaignPackage.sales_fee / 100
                                        ).toLocaleString("en", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}`}
                                      </MDTypography>
                                    )}
                                  </TableCell>
                                </>
                              )}
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                  {campaignPackage.expires_on}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                        <MDBox mt={3} align="right">
                          <MDButton
                            variant="contained"
                            color="dark"
                            startIcon={<Icon>money</Icon>}
                            onClick={() => {
                              if (campaignPackage.is_active) {
                                if (
                                  window.confirm(
                                    "Your current activation will be cancelled. Proceed?"
                                  ) === false
                                ) {
                                  return;
                                }
                              }
                              setSelectedPackage(null);
                              setSelectedPackageObject(null);
                              setPackageDuration(1);
                              setOpenPackageDialog(true);
                            }}
                          >
                            {campaignPackage.is_active ? "Change Package" : "Renew Activation"}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon color="error">warning</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontSize={14} fontWeight="light">
                          Campaign activation is required!
                        </MDTypography>
                        <MDBox>
                          <Divider />
                        </MDBox>
                        <MDBox mt={2} align="center">
                          <MDButton
                            variant="contained"
                            color="dark"
                            startIcon={<Icon>money</Icon>}
                            onClick={() => {
                              setSelectedPackage(null);
                              setSelectedPackageObject(null);
                              setPackageDuration(1);
                              setOpenPackageDialog(true);
                            }}
                          >
                            Activate
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          )}
          {campaign.campaign_type !== "DATA" && (
            <>
              <MDBox mt={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="light">
                          <b>Products</b>
                          <br />
                          <small>
                            Attach products from your inventory to sell under this campaign
                          </small>
                        </MDTypography>
                        <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <MDBox mr={1}>
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setTransferQty(0);
                                setSelectedProductTransfer(null);
                                setSelectedDestionationProductTransfer(null);
                                setOpenProductItemTransferDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>move_down</Icon>
                            </MDButton>
                          </MDBox>
                          {/* <MDBox mr={1}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setOpenUploadProductItemsDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                      </MDButton>
                    </MDBox> */}
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                // setProductTitle(null);
                                // setProductAttributes(null);
                                // setProductAmount(null);
                                setSelectedProduct(null);
                                setAttachProductQty(0);
                                setProductDispenseQty(1);
                                setProductMaxOrderQty(0);
                                setProductRestriction(null);
                                setOpenNewProductDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox p={2}>
                      <DataTable
                        table={{ columns: productTableColumns, rows: campaignProducts }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="light">
                          <b>Marketing / Promotional Materials</b>
                          <br />
                          <small>
                            Short videos, e-flyers, e-brochures, digital leave-behinds for selling
                            agents
                          </small>
                        </MDTypography>
                        <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setMaterialContent(null);
                                setMaterialDocType(null);
                                setMaterialTitle(null);
                                setOpenUploadMaterialDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                    <MDBox p={2}>
                      <DataTable
                        table={{ columns: materialTableColumns, rows: materials }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
              <MDBox mt={3}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="light">
                          <b>Customer Pool</b>
                          <br />
                          <small>
                            Restrict engagement to only customer profiles in a customer pool. Ideal for
                            3rd party collaborations
                          </small>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox mb={3}>
                      <DataTable
                        table={{
                          columns: campaignCustomerPoolsTableColumns,
                          rows: campaignCustomerPools,
                        }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries={false}
                        buttons
                        noEndBorder
                        canSearch={false}
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </>
          )}
          {campaign.campaign_type === "DATA" && (
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox>
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Accept Payment</b>
                      <br />
                      <small>
                        Need to collect payment during a data capture? Set an amount. Choose FIXED
                        or ANY to accommodate your different uses cases.
                      </small>
                    </MDTypography>
                  </MDBox>
                  {presetAmount === null ? (
                    <MDBox mt={2} align="center">
                      <MDBox my={2}>
                        <MDButton
                          variant="contained"
                          color="dark"
                          startIcon={<Icon>add</Icon>}
                          onClick={() => {
                            setPresetAmountTitle(null);
                            setPresetAmountAmt(null);
                            setPresetAmountType(null);
                            setPresetAmountFeeBearer("MERCHANT");
                            setPresetAmountMax(null);
                            setPresetAmountMin(null);
                            setOpenAddPresetAmountDialog(true);
                          }}
                        >
                          Add Amount
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  ) : (
                    <MDBox mt={2}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                DISPLAY NAME
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                TYPE
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                AMOUNT
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                MINIMUM
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                MAXIMUM
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                FEE BEARER
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={12}>
                                DELETE
                              </MDTypography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.display_name}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.amount_type === "VARIABLE"
                                  ? "ANY"
                                  : presetAmount.amount_type}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.amount !== null
                                  ? `${currency}${(presetAmount.amount / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`
                                  : "---"}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.minimum_amount !== null
                                  ? `${currency}${(
                                      presetAmount.minimum_amount / 100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`
                                  : "---"}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.maximum_amount !== null
                                  ? `${currency}${(
                                      presetAmount.maximum_amount / 100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}`
                                  : "---"}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                                {presetAmount.fee_bearer}
                              </MDTypography>
                            </TableCell>
                            <TableCell>
                              <MDButton
                                size="small"
                                variant="outlined"
                                color="error"
                                iconOnly
                                onClick={() => {
                                  if (window.confirm(`Remove?`) === true) {
                                    removePresetAmount(presetAmount.reference);
                                  }
                                }}
                              >
                                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                  delete
                                </Icon>
                              </MDButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>
          )}
          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Data Form</b>
                      <br />
                      <small>
                        Capture required information during an activity. Attach a data form.
                      </small>
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setSelectedDataForm(null);
                        setOpenAttachDataFormDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox mb={3}>
                  <DataTable
                    table={{ columns: campaignDataFormsTableColumns, rows: campaignDataForms }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries={false}
                    buttons
                    noEndBorder
                    canSearch={false}
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Locations (Geo-Fencing)</b>
                      <br />
                      <small>
                        Run campaigns at specific physical locations. Restrict access to only agents
                        or customers within specified locations.
                      </small>
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setLocationTitle(null);
                        setLocationLat(null);
                        setLocationLng(null);
                        setRestrictSalesToLocation(true);
                        setLocationRad(30);
                        setOpenLocationDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox>
                  <DataTable
                    table={{ columns: campaignLocationsTableColumns, rows: campaignLocations }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          {campaign.campaign_type !== "DATA" && (
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="light">
                        <b>Shipping Fees</b>
                        <br />
                        <small>
                          Need to collect shipping fees? Attach a shipping fee collection.
                        </small>
                      </MDTypography>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedShippingRate(null);
                          setOpenAttachShippingDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <DataTable
                      table={{ columns: campaignShippingTableColumns, rows: campaignShippingRates }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          )}

          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Agent Groups</b>
                      <br />
                      <small>Assign agent groups to campaign.</small>
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setSelectedAgentGroup(null);
                        setOpenNewSuperAgentDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox>
                  <DataTable
                    table={{ columns: superAgentTableColumns, rows: superAgents }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Supervisors</b>
                      <br />
                      <small>Assign supervisors to campaign.</small>
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setSelectedAggregator(null);
                        setOpenAddAggregatorDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox>
                  <DataTable
                    table={{ columns: aggregatorsTableColumns, rows: campaignAggregators }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          {/* <MDBox mt={3}>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    Aggregators
                  </MDTypography>
                  <MDButton
                    variant="contained"
                    color="dark"
                    iconOnly
                    onClick={() => {
                      setAggregatorSearch(null);
                      setAggregatorSearchName(null);
                      setOpenAddAggregatorDialog(true);
                    }}
                  >
                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox>
                <DataTable
                  table={{ columns: aggregatorsTableColumns, rows: aggregators }}
                  isSorted
                  entriesPerPage
                  showTotalEntries
                  buttons
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox> */}
          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Commissions</b>
                      <br />
                      <small>
                        Set the right commissions to pay your agents per transaction. Fixed amounts
                        or percentages supported.
                      </small>
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setSelectedProduct(null);
                            setOpenCreateSalesCommissionDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <DataTable
                    table={{ columns: commissionsTableColumns, rows: salesCommissions }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Incentives</b>
                      <br />
                      <small>Reward performing agents with incentives and bonuses</small>
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setSelectedProduct(null);
                            setOpenCreateSalesIncentiveDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <DataTable
                    table={{ columns: salesIncentiveTableColumns, rows: salesIncentives }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
          {campaign.campaign_type !== "DATA" && (
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="light">
                        <b>Customer Incentives</b>
                        <br />
                        <small>Reward your customers with incentives and bonuses</small>
                      </MDTypography>
                      <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                        <MDBox>
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setSelectedProduct(null);
                              setOpenCreatePurchaseIncentiveDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={2}>
                    <DataTable
                      table={{ columns: purchaseIncentiveTableColumns, rows: purchaseIncentives }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          )}

          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>Training</b>
                      <br />
                      <small>
                        Ensure your agents are well-trained before accessing this campaign. Go to
                        the <b>Trainings</b> menu for more information.
                      </small>
                    </MDTypography>
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setSelectedCourse(null);
                        setOpenAttachCourseDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox mb={3}>
                  <DataTable
                    table={{ columns: campaignCoursesTableColumns, rows: campaignCourses }}
                    isSorted
                    entriesPerPage={false}
                    showTotalEntries={false}
                    buttons
                    noEndBorder
                    canSearch={false}
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>3rd Party Access</b>
                      <br />
                      <small>
                        Grant third parties view-only access to insights, reports and agent
                        performances.
                      </small>
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setCampaignViewEmail(null);
                            setOpenCreateCampaignViewDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <DataTable
                    table={{ columns: campaignViewTableColumns, rows: campaignViews }}
                    isSorted
                    canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>

          <MDBox mt={3}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="light">
                      <b>API Endpoints</b>
                      <br />
                      <small>
                        Connect your existing software/CRM. Receive realtime data via configured API
                        webhook.
                      </small>
                    </MDTypography>
                    <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setApiEndpointType(null);
                            setApiEndpointUrl(null);
                            setOpenAddApiEndpointDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <DataTable
                    table={{ columns: endpointTableColumns, rows: endpoints }}
                    isSorted
                    canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries
                    buttons
                    noEndBorder
                  />
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default CampaignView;
